{
  "brand": {
    "tagline": "Alle deine Lieblingsgeschäfte, eine Mitgliedschaft."
  },
  "common": {
    "continue": "Weiter",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "done": "Fertig",
    "retry": "Erneut versuchen",
    "save": "Speichern",
    "edit": "Bearbeiten",
    "publish": "Veröffentlichen",
    "search": "Suchen",
    "learnMore": "Mehr erfahren",
    "notAvailable": "Nicht verfügbar",
    "offline": "Offline",
    "updated": "Aktualisiert {time}"
  },
  "tabs": {
    "home": "Start",
    "explore": "Entdecken",
    "activity": "Aktivität",
    "profile": "Profil"
  },
  "home": {
    "greeting": "Guten Tag",
    "title": "Deine Prämien",
    "showCard": "Meine Karte zeigen",
    "createCard": "Karte erstellen",
    "noCard": "Noch keine Karte",
    "createCardBody": "Erstelle eine kostenlose universelle Karte und sammle los.",
    "rewardReady": "Prämie bereit",
    "inProgress": "In Bearbeitung",
    "nearby": "In der Nähe entdecken",
    "emptyTitle": "Jetzt sammeln",
    "emptyBody": "Zeige deine Collectie-Karte in einem Partnergeschäft, um zu beginnen.",
    "stale": "Offline wird die zuletzt gespeicherte Aktualisierung angezeigt"
  },
  "card": {
    "universal": "Eine Karte · jedes Geschäft",
    "title": "Deine Collectie-Karte",
    "member": "Mitglied",
    "memberCode": "Mitglied {code}",
    "scanHint": "Bitte die Kasse, diese Karte zu scannen.",
    "wallet": "In Apple Wallet öffnen",
    "lastRefresh": "Zuletzt aktualisiert {time}",
    "brightness": "Während diese Karte geöffnet ist, wird die Bildschirmhelligkeit vorübergehend erhöht.",
    "codeUnavailable": "Noch kein scanbarer Code. Zeige dem Personal den Mitgliedscode oben.",
    "preparing": "Deine Karte wird vorbereitet …"
  },
  "membership": {
    "eyebrow": "Dein Fortschritt",
    "stamps": "Stempel",
    "progress": "{current} von {target} Stempeln",
    "progressTitle": "Stempelfortschritt",
    "nextReward": "Nächste Prämie",
    "availableRewards": "Verfügbare Prämien",
    "recentActivity": "Letzte Aktivität",
    "terms": "Programmbedingungen",
    "website": "Website des Geschäfts besuchen",
    "joined": "Beigetreten am {date}",
    "oneMore": "Noch ein Stempel bis zur Prämie",
    "rewardReady": "Deine Prämie ist bereit"
  },
  "reward": {
    "available": "Verfügbar",
    "redeemed": "Eingelöst",
    "expired": "Abgelaufen",
    "redeemAtCounter": "An der Kasse einlösen",
    "validUntil": "Gültig bis {date}"
  },
  "boost": {
    "unlockTitle": "App Boost freischalten",
    "unlockBody": "Verbinde die Collectie-App und erhalte bei deinem nächsten berechtigten Einkauf hier einen zusätzlichen Stempel.",
    "pendingTitle": "App Boost bereit",
    "pendingBody": "Dein nächster berechtigter Einkauf enthält einen zusätzlichen Stempel.",
    "applied": "App Boost angewendet",
    "expired": "App Boost abgelaufen",
    "reversed": "App Boost rückgängig gemacht",
    "validUntil": "Einlösen bis {date}"
  },
  "explore": {
    "eyebrow": "Sammle in deiner Nähe",
    "title": "Partner entdecken",
    "searchPlaceholder": "Kaffee, Mittagessen, Blumen …",
    "nearYou": "In deiner Nähe",
    "newPartners": "Neue Partner",
    "all": "Alle",
    "coffee": "Cafés & Tee",
    "food": "Essen",
    "shops": "Geschäfte",
    "locationPrompt": "Erlaube den Standortzugriff, um nahe Partner zu sortieren.",
    "noLocation": "Du kannst alle Partner auch ohne Standortfreigabe durchsuchen.",
    "viewMode": "Ansicht entdecken",
    "map": "Karte",
    "list": "Liste",
    "loading": "Partnerstandorte werden geladen …",
    "emptyTitle": "Noch keine Partnerstandorte",
    "emptyBody": "Neue Standorte erscheinen hier, sobald ihr Treueprogramm veröffentlicht ist.",
    "errorTitle": "Partner konnten nicht geladen werden",
    "errorBody": "Prüfe deine Verbindung und versuche es erneut.",
    "offline": "Offline werden gespeicherte Partnerstandorte angezeigt",
    "locate": "Meinen Standort verwenden",
    "locationDeniedTitle": "Standort ist deaktiviert",
    "yourLocation": "Dein Standort",
    "viewShop": "Geschäft ansehen",
    "website": "Website besuchen",
    "reward": "Treueprämie",
    "location": "Standort",
    "openInMaps": "In Karten öffnen",
    "stampGoal": "Stempelziel",
    "clearSearch": "Suche löschen"
  },
  "activity": {
    "eyebrow": "Deine Geschichte",
    "title": "Aktivität",
    "earn": "Stempel gesammelt",
    "bonus": "App Boost angewendet",
    "rewardIssued": "Prämie freigeschaltet",
    "redeem": "Prämie eingelöst",
    "adjustment": "Kontostand angepasst",
    "reversal": "Transaktion rückgängig gemacht",
    "expiry": "Prämie abgelaufen",
    "empty": "Deine Collectie-Aktivität erscheint hier.",
    "emptyTitle": "Noch keine Aktivität",
    "errorTitle": "Aktivität nicht verfügbar",
    "errorBody": "Prüfe deine Verbindung und versuche es erneut.",
    "loading": "Aktivität wird geladen …",
    "loadMore": "Frühere Aktivität laden",
    "loadingMore": "Frühere Aktivität wird geladen …"
  },
  "profile": {
    "eyebrow": "Ganz persönlich",
    "title": "Profil",
    "account": "Konto",
    "provisional": "Deine Prämien sind noch nicht geschützt",
    "protected": "Deine Prämien sind geschützt",
    "protect": "Prämien schützen",
    "signInApple": "Mit Apple fortfahren",
    "wallet": "Apple-Wallet-Karte",
    "replaceCard": "Karte ersetzen",
    "language": "Sprache",
    "languageSystem": "iPhone-App-Sprache verwenden",
    "serverLocale": "Sprache für Karten und Nachrichten",
    "privacy": "Datenschutz und Daten",
    "export": "Datenexport anfordern",
    "delete": "Konto löschen",
    "deleteTitle": "Collectie-Konto löschen?",
    "deleteBody": "Deine Karte funktioniert nicht mehr, Mitgliedschaften werden geschlossen und der Apple-Wallet-Pass wird von diesem iPhone entfernt. Transaktionsverläufe können für Prüfung und Betrugsprävention pseudonymisiert gespeichert bleiben.",
    "deleteConfirm": "Konto löschen",
    "deleting": "Konto wird gelöscht …",
    "deleteFailed": "Dein Konto konnte nicht gelöscht werden. Deine Karte funktioniert weiterhin; versuche es bitte erneut.",
    "browsing": "Ohne Karte stöbern",
    "memberCode": "Collectie-Karte",
    "privacyIntro": "Collectie verwendet nur die Daten, die für deine universelle Karte und die getrennten Treueprogramme der Geschäfte nötig sind.",
    "privacyIdentifiersTitle": "Karten- und Gerätekennungen",
    "privacyIdentifiersBody": "Wir speichern eine nicht zurückführbare Personen-ID, ein Kartenmerkmal und eine gehashte App-Installationskennung, damit deine Karte sicher erkannt wird. Rohdaten verbleiben im Schlüsselbund dieses iPhones und werden nie protokolliert.",
    "privacyRewardsTitle": "Mitgliedschaften und Einkaufsaktivität",
    "privacyRewardsBody": "Wir speichern Geschäftsmitgliedschaften, Stempel, Prämien und bestätigte Treuetransaktionen. Jedes Geschäft kann nur Aktivitäten seines eigenen Geschäfts sehen.",
    "privacyLocationTitle": "Standort",
    "privacyLocationBody": "Der Standort ist optional, wird erst nach Tippen auf „Meinen Standort verwenden“ angefragt und auf diesem iPhone zum Sortieren naher Geschäfte genutzt. Er wird nicht an Collectie gesendet.",
    "privacyTrackingTitle": "Kein Werbetracking",
    "privacyTrackingBody": "Collectie verwendet keine Werbetracker, verkauft keine personenbezogenen Daten und verknüpft deine Aktivitäten bei verschiedenen Geschäften nicht für Werbung.",
    "privacyRetentionTitle": "Löschung und Aufbewahrung",
    "privacyRetentionBody": "Das Löschen deines Kontos widerruft Zugangsdaten und pseudonymisiert direkte Kennungen. Unveränderliche Transaktionsdaten können für Prüfung, Betrugsprävention und rechtliche Pflichten aufbewahrt werden.",
    "privacyPolicy": "Vollständige Datenschutzerklärung lesen",
    "support": "Hilfe und Support",
    "version": "Version {version}",
    "versionLabel": "Version",
    "pilotUnavailable": "In dieser Pilotversion noch nicht verfügbar."
  },
  "onboarding": {
    "eyebrow": "Deine Treueprogramme, gesammelt",
    "checkingBody": "Dieses iPhone wird auf eine verfügbare Collectie-Karte geprüft.",
    "checkingTitle": "Deine Karte wird gesucht",
    "connecting": "Prämien werden verbunden …",
    "connectingBody": "Lass die App geöffnet, während wir deine Mitgliedschaften sicher übernehmen.",
    "createCard": "Meine Collectie-Karte erstellen",
    "creatingCard": "Deine Karte wird erstellt …",
    "createCardFailed": "Deine Karte konnte nicht erstellt werden. Prüfe deine Verbindung und versuche es erneut.",
    "cardStartsEmpty": "Deine Karte beginnt leer. Eine Geschäftsmitgliedschaft entsteht erst, wenn du sie dort verwendest.",
    "checkWalletAgain": "Apple Wallet erneut prüfen",
    "browseFirst": "Ohne Karte entdecken",
    "continueWithoutCard": "Ohne Verknüpfung fortfahren",
    "errorBody": "Deine Prämien wurden nicht verändert. Prüfe deine Verbindung und versuche es erneut.",
    "errorTitle": "Deine Karte konnte nicht verbunden werden",
    "foundTitle": "Willkommen zurück",
    "foundBody": "Wir haben deine Collectie-Karte und vorhandenen Prämien gefunden.",
    "connect": "Diese Karte verbinden",
    "noCardTitle": "Mit Collectie starten",
    "noCardBody": "Erstelle jetzt eine Karte oder schütze Prämien, die du bereits hast.",
    "noManualEntry": "Keine Mitgliedsnummer zum Eingeben",
    "protectExisting": "Vorhandene Prämien schützen",
    "separateShops": "Jedes Geschäft behält seine eigenen Prämien",
    "skip": "Jetzt nicht",
    "valuePreserved": "Vorhandene Guthaben bleiben unverändert"
  },
  "join": {
    "eyebrow": "Prämien zuerst in Wallet",
    "title": "Prämien bei {merchant} sammeln",
    "noApp": "Keine App erforderlich.",
    "noPii": "Vor deiner Karte sind weder E-Mail noch Konto erforderlich.",
    "body": "Speichere deine Collectie-Karte in Apple Wallet und nutze sie in jedem Partnergeschäft.",
    "addWallet": "Zu Apple Wallet hinzufügen",
    "alreadyMember": "Hast du bereits Collectie? Öffne deine Karte.",
    "privacy": "Wenn du fortfährst, stimmst du den Treuebedingungen zu und bestätigst den Datenschutzhinweis.",
    "protectTitle": "Deine Karte ist bereit",
    "protectBody": "Installiere Collectie, um deine Prämien zu schützen und alle Partner zu entdecken.",
    "getApp": "Collectie-App laden",
    "program": "Sammle {target} Stempel und erhalte eine Prämie.",
    "creating": "Deine Karte wird erstellt …",
    "added": "Karte bereit",
    "membershipReady": "Mitgliedschaft bereit",
    "actionError": "Deine Mitgliedschaft konnte nicht vorbereitet werden. Es wurde kein Einkauf und keine Prämie hinzugefügt. Versuche es erneut.",
    "fallback": "Einige Inhalte des Geschäfts werden auf Englisch angezeigt.",
    "stampsToReward": "Stempel bis zur Prämie",
    "perPurchase": "pro bestätigtem Einkauf",
    "reward": "Deine Prämie",
    "previewLabel": "Deine universelle Mitgliedskarte",
    "previewTitle": "Eine Karte für jedes Collectie-Geschäft",
    "atThisShop": "In diesem Geschäft",
    "merchantWebsite": "Website des Geschäfts besuchen",
    "programDetails": "Was du hier sammelst",
    "terms": "Treuebedingungen",
    "safeJoin": "Dieser Code tritt einer Mitgliedschaft bei oder öffnet sie. Einkäufe werden separat an der Kasse bestätigt.",
    "loading": "Prämien des Geschäfts werden geladen …",
    "loadErrorTitle": "Dieses Geschäft konnte nicht geladen werden",
    "loadErrorBody": "Es wurde keine Mitgliedschaft oder kein Guthaben erstellt. Prüfe deine Verbindung und versuche es erneut.",
    "notFoundTitle": "Dieses Geschäft ist nicht verfügbar",
    "notFoundBody": "Der Standort oder das Treueprogramm ist möglicherweise pausiert. Frage im Geschäft nach dem aktuellen Collectie-Code."
  },
  "merchant": {
    "auth": {
      "eyebrow": "Händlerzugang",
      "title": "Bei Collectie anmelden",
      "body": "Verwalte dein Treueprogramm und halte den Checkout in einem sicheren Arbeitsbereich in Bewegung.",
      "formLabel": "Händleranmeldung",
      "noPasswordTitle": "Kein Passwort merken",
      "noPasswordBody": "Wir senden einen kurz gültigen Code an deine freigegebene Händler-E-Mail-Adresse.",
      "email": "Geschäftliche E-Mail-Adresse",
      "emailTitle": "Mit E-Mail fortfahren",
      "emailHelp": "Verwende die E-Mail-Adresse, zu der dich deine Inhaberin oder dein Manager eingeladen hat.",
      "sendCode": "Anmeldecode senden",
      "sending": "Code wird gesendet …",
      "code": "Sechsstelliger Code",
      "codeTitle": "Posteingang prüfen",
      "codeHelp": "Gib den an {email} gesendeten Code ein.",
      "localCode": "Lokaler Testcode: {code}",
      "verify": "Prüfen und fortfahren",
      "verifying": "Wird geprüft …",
      "changeEmail": "Andere E-Mail-Adresse verwenden",
      "requestError": "Ein Code konnte nicht gesendet werden. Prüfe die Adresse und versuche es erneut.",
      "verifyError": "Dieser Code konnte nicht bestätigt werden. Prüfe ihn und versuche es erneut.",
      "accessCodeTitle": "Zugangscode verwenden",
      "accessCodeBody": "Gib den für diesen Händlerbereich ausgestellten Zugangscode ein.",
      "accessCode": "Zugangscode",
      "accessCodeContinue": "Weiter",
      "accessCodeSigningIn": "Arbeitsbereich wird geöffnet …",
      "accessCodeError": "Dieser Zugangscode wurde nicht akzeptiert. Prüfe ihn und versuche es erneut.",
      "useEmailCode": "Stattdessen E-Mail-Code verwenden",
      "useAccessCode": "Zugangscode verwenden",
      "openTill": "Diese Kasse öffnen",
      "signOut": "Abmelden",
      "signingOut": "Abmeldung läuft …",
      "signOutError": "Du konntest nicht abgemeldet werden. Versuche es erneut, bevor du dieses Gerät verlässt.",
      "emailOtpSubject": "Dein Collectie-Anmeldecode",
      "emailOtpLead": "Dein Collectie-Anmeldecode lautet {code}.",
      "emailOtpExpiry": "Dieser Code läuft in 5 Minuten ab.",
      "emailOtpIgnore": "Wenn du diesen Code nicht angefordert hast, kannst du diese E-Mail ignorieren."
    },
    "operator": {
      "eyebrow": "Pilotbetrieb",
      "title": "Ein Geschäft einrichten",
      "body": "Erstelle Händler, ersten Standort und Inhaberzugang in einem geprüften Vorgang. Das Treueprogramm wird eingerichtet, nachdem sich der Inhaber angemeldet hat.",
      "accessEyebrow": "Geschützter Vorgang",
      "accessTitle": "Operator-Zugang",
      "accessBody": "Verwende den Staging- oder Produktionsschlüssel eines freigegebenen Collectie-Operators. Er wird nur mit dieser Anfrage gesendet und nie im Browser gespeichert.",
      "operatorKey": "Einrichtungsschlüssel für Operator",
      "shopEyebrow": "Händleridentität",
      "shopTitle": "Geschäftsdetails",
      "merchantNameEn": "Geschäftsname — Englisch",
      "merchantNameZhHant": "Geschäftsname — Traditionelles Chinesisch (optional)",
      "legalName": "Rechtlicher Name",
      "merchantSlug": "Händler-Slug",
      "currency": "Währungscode",
      "category": "Kategorie für Entdecken",
      "categoryCafeTea": "Cafés & Tee",
      "categoryFood": "Essen",
      "categoryShops": "Geschäfte",
      "ownerEyebrow": "Kontoinhaber",
      "ownerTitle": "Inhaberzugang",
      "ownerName": "Name des Inhabers",
      "ownerEmail": "E-Mail des Inhabers",
      "ownerLocale": "Bevorzugte Sprache",
      "locationEyebrow": "Erster öffentlicher Standort",
      "locationTitle": "Standort- und Kartendetails",
      "locationNameEn": "Standortname — Englisch",
      "locationNameZhHant": "Standortname — Traditionelles Chinesisch (optional)",
      "locationInternalName": "Interner Standortname",
      "locationSlug": "Permanenter URL-Slug für Beitritt",
      "address": "Straßenadresse",
      "locality": "Stadt",
      "region": "Region (optional)",
      "postalCode": "Postleitzahl",
      "countryCode": "Ländercode",
      "timezone": "Zeitzone",
      "latitude": "Breitengrad",
      "longitude": "Längengrad",
      "authorizationError": "Der Operator-Schlüssel wurde nicht akzeptiert. Es wurde kein Geschäft erstellt.",
      "submitError": "Das Geschäft konnte nicht erstellt werden. Prüfe alle Felder und wiederhole dieselbe Anfrage.",
      "submitNote": "Dies erstellt ein aktives Geschäft, einen aktiven Inhaber und einen geocodierten Standort. Es veröffentlicht kein Treueprogramm und vergibt keinen Wert.",
      "submit": "Pilotgeschäft erstellen",
      "submitting": "Pilotgeschäft wird erstellt …",
      "completeEyebrow": "Geschäft erstellt",
      "completeTitle": "Onboarding des Inhabers kann beginnen",
      "completeBody": "{email} kann jetzt einen sicheren Anmeldecode anfordern und das erste Treueprogramm veröffentlichen.",
      "joinUrl": "Permanente Beitritts-URL",
      "openSignIn": "Händleranmeldung öffnen"
    },
    "shell": {
      "loading": "Deine sichere Sitzung wird wiederhergestellt …",
      "connectionLabel": "Verbindung",
      "unavailableTitle": "Dein Arbeitsbereich konnte nicht geladen werden",
      "unavailableBody": "Es wurden keine Änderungen vorgenommen. Prüfe deine Verbindung und versuche es erneut.",
      "managementNavigation": "Händlerverwaltung",
      "backToOverview": "Zurück zur Übersicht",
      "locationCount": "Aktive Standorte: {count}",
      "sectionPending": "Dieser Verwaltungsbereich ist der nächste schlanke Schritt. Deine aktuellen Händlerdaten bleiben unverändert."
    },
    "nav": {
      "overview": "Start",
      "program": "Treueprogramm",
      "shop": "Geschäftsprofil",
      "locations": "Standorte",
      "staff": "Team & Kassen",
      "transactions": "Aktivität",
      "campaigns": "Kampagnen",
      "settings": "Einstellungen",
      "scanner": "Scanner",
      "dashboard": "Übersicht",
      "activity": "Transaktionen"
    },
    "overview": {
      "welcome": "Schön, dich zu sehen, {name}",
      "title": "Heute auf einen Blick",
      "transactions": "Transaktionen",
      "newMembers": "Neue Mitglieder",
      "rewardsRedeemed": "Eingelöste Prämien",
      "appBoosts": "App Boosts",
      "recent": "Letzte Aktivität"
    },
    "pageDescription": {
      "overview": "Ein klarer Blick auf heute, dein Treueprogramm und alles, was Aufmerksamkeit braucht.",
      "transactions": "Prüfe bestätigte Checkout-Aktivitäten und korrigiere berechtigte Transaktionen.",
      "program": "Gestalte das Treueerlebnis, das deine Kundschaft in jedem Geschäft sieht.",
      "shop": "Halte deine Identität beim Beitritt, in Wallet und in der Collectie-App konsistent.",
      "locations": "Verwalte Geschäftsdetails und den öffentlichen QR-Code, der eine Mitgliedschaft startet.",
      "staff": "Bestimme, wer das Geschäft verwalten kann und welche Kassen den Checkout ausführen dürfen."
    },
    "till": {
      "open": "Kasse öffnen",
      "openHint": "Geteilter Checkout",
      "checkingDevice": "Kasse wird geprüft",
      "sharedCounter": "Anonyme geteilte Kasse",
      "menu": "Kassenoptionen",
      "manageBusiness": "Geschäft verwalten",
      "back": "Zurück",
      "mainPage": "Startseite",
      "navigation": "Seitennavigation"
    },
    "program": {
      "title": "Treueprogramm",
      "draft": "Entwurf",
      "active": "Aktiv",
      "visitTemplate": "Besuchsstempel",
      "itemTemplate": "Stempel für Warengruppen",
      "threshold": "Benötigte Stempel",
      "rewardLabel": "Prämie",
      "dailyLimit": "Tägliches Sammellimit",
      "expiry": "Ablauf der Prämie",
      "preview": "Vorschau der Kundenansicht",
      "publishConfirm": "Diese Version veröffentlichen? Bestehende Transaktionen behalten ihre ursprünglichen Bedingungen.",
      "type": "Programmtyp",
      "target": "Benötigte Stempel",
      "reward": "Prämie",
      "appBoost": "App Boost",
      "appBoostDescription": "Füge beim nächsten bestätigten Einkauf nach Aktivierung der App einen Bonusstempel hinzu.",
      "templateHeading": "Sichere Vorlage wählen",
      "visitHelp": "Vergib Stempel für bestätigte berechtigte Besuche.",
      "itemHelp": "Vergib Stempel nur für kontrollierte Warengruppen.",
      "englishContent": "Englische Inhalte",
      "chineseContent": "Traditionelle chinesische Inhalte",
      "optional": "Optional",
      "name": "Programmname",
      "description": "Beschreibung",
      "terms": "Bedingungen",
      "itemGroups": "Berechtigte Warengruppen",
      "addItemGroup": "Warengruppe hinzufügen",
      "itemKey": "Interner Schlüssel",
      "itemEnglish": "Englische Bezeichnung",
      "itemChinese": "Traditionelle chinesische Bezeichnung",
      "removeItemGroup": "Warengruppe entfernen",
      "fallbackPreview": "Englische Rückfallanzeige",
      "fallbackWarning": "Traditionelles Chinesisch ist leer. Kundinnen und Kunden sehen Englisch.",
      "history": "Versionsverlauf",
      "version": "Version {version}",
      "publishedThreshold": "Veröffentlichte Stempelschwelle",
      "noHistory": "Es wurde noch keine Version veröffentlicht.",
      "previewName": "Unbenanntes Programm",
      "loading": "Programmentwurf wird geladen …",
      "loadError": "Dieses Programm konnte nicht geladen werden. Es wurden keine Änderungen vorgenommen.",
      "permissionTitle": "Programmzugang nicht verfügbar",
      "permissionBody": "Eine Inhaberin, ein Inhaber oder ein global berechtigter Manager muss dieses Programm verwalten.",
      "unsaved": "Ungespeicherte Änderungen",
      "saving": "Wird gespeichert …",
      "saved": "Entwurf gespeichert.",
      "published": "Eine neue unveränderliche Version ist aktiv.",
      "saveError": "Der Entwurf konnte nicht gespeichert werden. Prüfe die Felder und versuche es erneut.",
      "publishError": "Der Entwurf konnte nicht veröffentlicht werden. Aktualisiere den Entwurf und versuche es erneut.",
      "publishTitle": "Neue Version veröffentlichen?",
      "validationRequired": "Dieses Feld ist erforderlich.",
      "validationFormat": "Verwende das erforderliche sichere Format.",
      "validationDuplicate": "Dieser Wert muss eindeutig sein.",
      "validationLength": "Dieser Inhalt ist zu lang.",
      "validationRange": "Verwende einen Wert im erlaubten Bereich.",
      "interimHeading": "Zwischenprämien",
      "interimHelp": "Füge Prämien vor Abschluss der Karte in aufsteigender Stempelzahl hinzu. Zwischenprämien behalten den Fortschritt. Nur die letzte Prämie setzt die Karte zurück. Ohne chinesischen Namen wird Englisch angezeigt.",
      "interimNumber": "Zwischenprämie {number}",
      "interimStamps": "Benötigte Stempel",
      "interimEnglish": "Prämienname auf Englisch",
      "interimChinese": "Prämienname auf Chinesisch (optional)",
      "addInterim": "Zwischenprämie hinzufügen",
      "removeInterim": "Zwischenprämie entfernen",
      "milestoneSummary": "{stamps} Stempel: {reward}",
      "finalStamps": "Stempel bis zur vollen Karte",
      "finalReward": "Prämie für die volle Karte"
    },
    "scanner": {
      "title": "Kundschaft scannen",
      "ready": "Bereit zum Scannen",
      "cameraHelp": "Platziere den Collectie-Barcode im Rahmen.",
      "addStamp": "1 Stempel hinzufügen",
      "redeem": "Prämie einlösen",
      "success": "Transaktion abgeschlossen",
      "duplicate": "Bereits abgeschlossen — das ursprüngliche Ergebnis wird angezeigt.",
      "permissionTitle": "Kamerazugriff erforderlich",
      "permissionBody": "Der Kamerazugriff wurde blockiert. Erlaube ihn in den Browsereinstellungen und tippe erneut auf „Kamera aktivieren“. Du kannst auch den freigegebenen Fallback nutzen.",
      "offlineTitle": "Verbindung verloren",
      "offlineBody": "Es wurde keine Prämie hinzugefügt. Stelle die Verbindung wieder her und versuche dieselbe Aktion erneut.",
      "start": "Scanner öffnen",
      "prompt": "Collectie-Karte der Kundschaft scannen",
      "hint": "Halte dieses Gerät mit dem richtigen Standort gekoppelt. Erst nach Bestätigung durch die Kasse wird eine Transaktion erstellt.",
      "manual": "Freigegebenen Fallback verwenden",
      "deviceScope": "Gekoppeltes Checkout-Gerät",
      "deviceChecking": "Dieses Checkout-Gerät wird geprüft …",
      "deviceCheckingBody": "Der Scanner öffnet erst, wenn dieser Browser eine gekoppelte Berechtigung hat.",
      "deviceCheckError": "Dieses Gerät konnte nicht geprüft werden",
      "pairTitle": "Dieses Checkout-Gerät koppeln",
      "pairBody": "Gib den Einmalcode einer berechtigten Managerin oder eines berechtigten Managers ein. Die Geräteberechtigung bleibt vor Browser-Skripten geschützt.",
      "pairingCode": "Einmaliger Kopplungscode",
      "pairHelp": "Codes bestehen aus 8 Buchstaben oder Ziffern und laufen nach 10 Minuten ab.",
      "pairError": "Dieser Code ist ungültig, abgelaufen oder bereits verwendet. Es wurde kein Gerät gekoppelt.",
      "pairing": "Gerät wird gekoppelt …",
      "pairAction": "Gerät koppeln",
      "checking": "Kundschaft wird geprüft",
      "noValueYet": "Es wurde noch kein Stempel oder keine Prämie hinzugefügt.",
      "cardUnknownTitle": "Karte nicht erkannt",
      "cardUnknownBody": "Bitte die Kundschaft, ihre aktuelle Collectie-Karte zu öffnen, und scanne dann erneut.",
      "quoteExpiredTitle": "Bestätigung abgelaufen",
      "quoteExpiredBody": "Es wurde kein Wert hinzugefügt. Scanne die Kundenkarte erneut für eine neue Bestätigung.",
      "actionErrorTitle": "Aktion nicht verfügbar",
      "actionErrorBody": "Es wurde kein Wert hinzugefügt. Prüfe Karte und Gerät und versuche es erneut.",
      "scanAgain": "Erneut scannen",
      "confirmLabel": "Kundschaft bestätigen",
      "currentBalance": "Aktueller Stempelstand",
      "quoteWindow": "Diese Bestätigung ist nur kurz gültig. Der Kontostand ändert sich erst nach deiner Bestätigung.",
      "confirmEarn": "+{quantity} Stempel bestätigen",
      "committing": "Stempel wird hinzugefügt …",
      "commitPending": "Lass diese Seite geöffnet. Bei einem erneuten Versuch wird dieselbe sichere Anfrage verwendet.",
      "retrySameAction": "Dieselbe Aktion wiederholen",
      "balanceNow": "Jetzt {balance} Stempel",
      "earnedReceipt": "+{quantity} aus dem maßgeblichen Hauptbuch hinzugefügt.",
      "earnedRewardReceipt": "+{quantity} Stempel hinzugefügt. Eine Prämie ist jetzt freigeschaltet und bereit zur Nutzung.",
      "nextCustomer": "Nächste Kundschaft scannen",
      "cameraStarting": "Kamera wird gestartet",
      "cameraIdle": "Kamera nicht aktiviert",
      "cameraUnavailableBody": "Live-QR-Scannen ist hier nicht verfügbar. Nutze den freigegebenen Fallback für denselben sicheren Bestätigungsablauf.",
      "enableCamera": "Kamera aktivieren",
      "manualLabel": "Kartenberechtigung der Kundschaft",
      "manualHelp": "Füge nur aus dem freigegebenen Support-Ablauf ein. Sie wird direkt nach der Prüfung gelöscht.",
      "checkCustomer": "Kundschaft prüfen",
      "availableRewards": "Verfügbare Prämien",
      "rewardReady": "Bereit zur Nutzung",
      "confirmRedeem": "Einlösung bestätigen",
      "rewardStaleTitle": "Prämie geändert",
      "rewardStaleBody": "Es wurde keine Prämie eingelöst. Scanne erneut, um die aktuellen Prämien der Kundschaft zu laden.",
      "rewardRedeemed": "Prämie eingelöst",
      "redeemedReceipt": "Das maßgebliche Hauptbuch hat diese Einlösung erfasst.",
      "addStampFor": "Stempel für {item} hinzufügen",
      "confirmEarnItem": "{quantity} Stempel hinzufügen · {item}",
      "chooseItemGroup": "Welche Warengruppe?",
      "dailyLimitReached": "Das heutige Limit von {limit} Stempeln in diesem Geschäft ist ausgeschöpft. Prämien können weiterhin eingelöst werden.",
      "cameraPermissionHelp": "Tippe auf „Kamera aktivieren“ und erlaube den Kamerazugriff, wenn dein Browser danach fragt. Scanne damit die Collectie-Karte des Kunden.",
      "cameraErrorBody": "Die Kamera konnte nicht starten oder scannen. Schließe andere Apps, die sie verwenden, und tippe zum erneuten Versuch auf „Kamera aktivieren“. Du kannst auch den freigegebenen Fallback nutzen.",
      "cameraUnavailable": "Kamera nicht verfügbar",
      "cameraError": "Scanner nicht verfügbar"
    },
    "staff": {
      "title": "Team & Kassen",
      "managementAccess": "Verwaltungszugang bleibt persönlich",
      "managementAccessBody": "Inhaber und Manager melden sich mit ihrer eigenen E-Mail-Adresse oder ihrem Zugangscode an. Kassenpersonal verwendet die gekoppelte Kasse ohne den Verwaltungsbereich zu öffnen.",
      "tillsEyebrow": "Checkout-Zugang",
      "tillsTitle": "Gekoppelte Kassen",
      "tillsBody": "Jede Kasse ist ein anonymer gemeinsamer Schalter, der an einen Geschäftsstandort gebunden ist. Ihr Gerätename erscheint in jedem Checkout-Datensatz.",
      "activeCount": "{count} aktiv",
      "loadingDevices": "Gekoppelte Kassen werden geladen …",
      "devicesError": "Gekoppelte Kassen konnten nicht geladen werden. Keine Geräteeinstellungen wurden geändert.",
      "emptyTills": "Noch keine Kassen gekoppelt",
      "emptyTillsBody": "Erstelle unten einen Einmalcode und gib ihn dann am Checkout-Gerät ein.",
      "neverUsed": "Noch nicht geöffnet",
      "lastSeen": "Zuletzt geöffnet {time}",
      "status": {
        "active": "Aktiv",
        "revoked": "Widerrufen"
      },
      "revokeConfirm": "Diese Kasse funktioniert sofort nicht mehr.",
      "revokeAction": "Kasse widerrufen",
      "revokeError": "Diese Kasse konnte nicht widerrufen werden. Sie kann möglicherweise weiterhin Kundschaft abfertigen.",
      "pairEyebrow": "Einen Schalter hinzufügen",
      "invite": "Personal einladen",
      "pair": "Checkout-Gerät koppeln",
      "pairBody": "Benenne den Schalter und erstelle einen kurz gültigen Code. Gib ihn einmal auf dem Gerät ein, damit dieser Browser Checkout-Zugang für den ausgewählten Standort erhält.",
      "deviceLabel": "Name des Checkout-Geräts",
      "deviceLabelHelp": "Verwende einen Namen, den das Personal erkennt, etwa „iPhone vordere Kasse“.",
      "createCode": "Einmalcode erstellen",
      "creatingCode": "Code wird erstellt …",
      "codeTitle": "Einmaliger Kopplungscode",
      "codeBody": "Gib diesen Code einmal in „Kasse öffnen“ ein. Er läuft nach zehn Minuten ab und kann nicht wiederverwendet werden.",
      "expiresAt": "Läuft ab {time}",
      "copyCode": "Code kopieren",
      "copied": "Code kopiert",
      "generateAnother": "Weiteren Code erstellen",
      "createError": "Der Code konnte nicht erstellt werden. Es wurde kein Gerät gekoppelt. Prüfe den Standort und versuche es erneut.",
      "noLocations": "Füge einen Standort hinzu oder aktiviere ihn, bevor du ein Checkout-Gerät koppelst.",
      "revoke": "Widerrufen",
      "owner": "Inhaber",
      "manager": "Manager",
      "cashier": "Kasse"
    },
    "dashboard": {
      "title": "Übersicht",
      "statusLabel": "Geschäftsstatus",
      "glance": "Heute auf einen Blick",
      "todayTransactions": "Heutige Transaktionen",
      "activeMembers": "Aktive Mitglieder",
      "rewardsRedeemed": "Eingelöste Prämien",
      "programLive": "Veröffentlicht und an allen aktiven Standorten sammelbar.",
      "recent": "Letzte Aktivität",
      "loading": "Heutige Übersicht wird geladen …",
      "errorTitle": "Die Übersicht konnte nicht geladen werden",
      "errorBody": "Keine Daten wurden geändert. Prüfe deine Verbindung und versuche es erneut.",
      "permissionTitle": "Übersicht nicht verfügbar",
      "permissionBody": "Deine aktuelle Händlerrolle kann diese Übersicht nicht sehen.",
      "localToday": "Heute am Standort",
      "serverTruth": "Aktive Serverdatensätze",
      "programPublished": "Veröffentlichtes Programm",
      "programDraft": "Programmeinrichtung",
      "checkoutReady": "Bereit für Checkout",
      "setupRequired": "Einrichtung braucht Aufmerksamkeit",
      "programNotPublished": "Veröffentliche dein erstes Treueprogramm",
      "programThreshold": "Sammle {threshold}; der öffentliche Beitritt ist bei {ready} von {active} aktiven Standorten bereit.",
      "publishPrompt": "Schließe das Programm ab und veröffentliche es, bevor du einen öffentlichen Beitritts-QR-Code zeigst.",
      "emptyTitle": "Noch keine bestätigte Aktivität",
      "emptyBody": "Bestätigte Checkout-Ereignisse erscheinen hier."
    },
    "shop": {
      "title": "Geschäftsprofil",
      "loading": "Dein Geschäftsprofil wird geladen …",
      "errorTitle": "Dein Geschäftsprofil konnte nicht geladen werden",
      "errorBody": "Keine Geschäftsdaten wurden geändert. Prüfe deine Verbindung und versuche es erneut.",
      "permissionTitle": "Geschäftsprofil nicht verfügbar",
      "permissionBody": "Deine aktuelle Händlerrolle kann dieses Geschäftsprofil nicht sehen.",
      "identityEyebrow": "Identität für Kundschaft",
      "identityTitle": "Mach es eindeutig zu deinem Geschäft",
      "identityBody": "Diese Angaben erscheinen, wenn Kundschaft beitritt, ihre Mitgliedschaft öffnet oder dein Geschäft in Collectie entdeckt.",
      "discoveryEyebrow": "Collectie Explore",
      "discoveryTitle": "Bestimme, wann Kundschaft dich finden kann",
      "discoveryListed": "Gelistet",
      "discoveryUnlisted": "Nicht gelistet",
      "discoveryListedBody": "Kundschaft kann dieses Geschäft in Collectie Explore finden. Der permanente Beitritts-QR-Code bleibt auch nach dem Entfernen verfügbar.",
      "discoveryUnlistedBody": "Du kannst Programm und permanenten Beitritts-QR-Code privat testen. Dieses Geschäft erscheint nicht in Collectie Explore.",
      "discoveryList": "Geschäft in Explore listen",
      "discoveryUnlist": "Geschäft aus Explore entfernen",
      "discoveryListing": "Geschäft wird gelistet …",
      "discoveryUnlisting": "Geschäft wird entfernt …",
      "discoveryListedSaved": "Das Geschäft ist jetzt in Explore gelistet.",
      "discoveryUnlistedSaved": "Das Geschäft ist nicht mehr in Explore gelistet. Sein permanenter Beitritts-QR-Code funktioniert weiterhin.",
      "discoveryNotReady": "Veröffentliche ein Treueprogramm und vervollständige mindestens einen aktiven Standort, bevor du dieses Geschäft listest.",
      "discoveryError": "Die Explore-Sichtbarkeit konnte nicht geändert werden. Es wurde keine unbekannte Änderung übernommen; verbinde dich erneut und versuche es noch einmal.",
      "discoveryReadOnly": "Nur global berechtigte Inhaber und Manager können die Explore-Sichtbarkeit ändern.",
      "chooseLogo": "Logo wählen",
      "logoHelp": "PNG, JPEG oder WebP. Quadratische Gestaltung funktioniert am besten; maximal 512 KB.",
      "logoSave": "Dieses Logo hochladen",
      "logoSaving": "Logo wird hochgeladen …",
      "logoError": "Das Logo konnte nicht hochgeladen werden. Prüfe Dateityp und Größe und versuche es erneut.",
      "english": "Englisch",
      "traditionalChinese": "Traditionelles Chinesisch (optional)",
      "displayName": "Geschäftsname",
      "description": "Kurzbeschreibung",
      "category": "Geschäftskategorie",
      "categories": {
        "cafe_tea": "Café & Tee",
        "food": "Essen",
        "shops": "Geschäfte"
      },
      "website": "Website (optional)",
      "brandColor": "Markenfarbe",
      "customerPreview": "Vorschau für Kundschaft",
      "previewFallback": "Dein Geschäft",
      "previewDescriptionFallback": "Eine kurze Vorstellung hilft der Kundschaft, diese Mitgliedschaft wiederzuerkennen.",
      "previewWallet": "Zu Apple Wallet hinzufügen",
      "previewSurfaces": "Eine kompakte Vorschau der Identität auf Beitrittsseiten und in der Collectie-App. Das Wallet-Layout folgt Apples Passformat.",
      "qrEyebrow": "Öffentlicher Beitritts-QR",
      "qrTitle": "Gestalte ihn, ohne ihn fragil zu machen",
      "qrBody": "Das permanente Ziel bleibt unverändert. Das Styling gilt für jeden Standort-QR-Code.",
      "qrPreviewAlt": "Vorschau des gestalteten öffentlichen Beitritts-QR-Codes",
      "qrPreviewError": "Diese Farbkombination ist nicht scansicher. Erhöhe den Kontrast und halte den Vordergrund dunkler.",
      "qrForeground": "QR-Farbe",
      "qrBackground": "Hintergrund",
      "qrShape": "Punktform",
      "qrStyles": {
        "square": "Quadratisch",
        "rounded": "Abgerundet",
        "dots": "Punkte"
      },
      "qrLogo": "Logo in der Mitte platzieren",
      "qrLogoHelp": "Verfügbar, nachdem ein Logo hochgeladen wurde.",
      "qrGuardrail": "Collectie sorgt für eine Ruhezone, starken Kontrast, hohe Fehlerkorrektur und eine begrenzte Logofläche, damit der QR-Code zuverlässig bleibt.",
      "validation": "Prüfe den erforderlichen englischen Namen, die HTTPS-Website, Beschreibungen und scansichere QR-Farben.",
      "saveError": "Das Profil konnte nicht gespeichert werden. Es wurde keine unbekannte Änderung übernommen; verbinde dich erneut und versuche es noch einmal.",
      "readOnly": "Nur Inhaber und Manager können das Geschäftsprofil ändern.",
      "saving": "Profil wird gespeichert …",
      "save": "Geschäftsprofil speichern",
      "saved": "Geschäftsprofil gespeichert. Kundenseiten verwenden die neue Identität."
    },
    "locations": {
      "eyebrow": "Geschäftsstandorte",
      "title": "Standorte und öffentlicher QR",
      "body": "Jeder Standort hat einen permanenten öffentlichen Beitritts-QR-Code. Lade ihn für Kasse, Schaufenster, Speisekarte oder Druckmaterial herunter.",
      "loading": "Standorte werden geladen …",
      "errorTitle": "Standorte konnten nicht geladen werden",
      "errorBody": "Kein Standort wurde geändert. Prüfe deine Verbindung und versuche es erneut.",
      "permissionTitle": "Standorte nicht verfügbar",
      "permissionBody": "Deine aktuelle Händlerrolle kann diese Standorte nicht sehen.",
      "add": "Standort hinzufügen",
      "newEyebrow": "Neuer Pilotstandort",
      "newTitle": "Standortdetails",
      "internalName": "Interner Standortname",
      "slug": "Permanenter URL-Slug",
      "displayNameEn": "Anzeigename — Englisch",
      "displayNameZhHant": "Anzeigename — Traditionelles Chinesisch (optional)",
      "addressLine1": "Straßenadresse",
      "addressLine2": "Adresszusatz (optional)",
      "locality": "Stadt",
      "region": "Region (optional)",
      "postalCode": "Postleitzahl",
      "countryCode": "Ländercode",
      "timezone": "Zeitzone",
      "latitude": "Breitengrad",
      "longitude": "Längengrad",
      "coordinate": "Kartenkoordinate",
      "coordinateHelp": "Koordinaten verorten dieses Geschäft in der zukünftigen Kartenansicht. Sie geben keine Transaktionsberechtigung.",
      "validation": "Prüfe URL-Slug, Adresse, Koordinaten und den erforderlichen englischen Anzeigenamen.",
      "conflict": "Dieser Standort oder diese URL existiert bereits. Es wurde nichts erstellt.",
      "saveError": "Das Ergebnis ist unbekannt. Verbinde dich erneut und wiederhole dieselbe Standortanfrage.",
      "retrySame": "Dieselbe Standortanfrage wiederholen",
      "saving": "Standort wird erstellt …",
      "save": "Standort erstellen",
      "created": "Der Standort wurde mit einer prüfbaren permanenten Beitritts-URL erstellt.",
      "emptyTitle": "Noch keine Standorte",
      "emptyBody": "Füge den ersten Pilotstandort hinzu, um eine permanente öffentliche Beitritts-URL vorzubereiten.",
      "qrTitle": "Permanenter öffentlicher QR",
      "publicReady": "Öffentlicher Beitritt ist bereit",
      "publicPending": "Veröffentliche das Programm, bevor du diesen QR-Code zeigst",
      "qrSafety": "Dieser QR-Code öffnet nur den öffentlichen Beitrittsablauf. Er kann keine Stempel hinzufügen oder eine Prämie einlösen.",
      "customizeQr": "Stil anpassen",
      "qrPreviewAlt": "Öffentlicher Beitritts-QR für {name}",
      "qrPreviewLoading": "QR wird vorbereitet …",
      "downloadQr": "QR herunterladen",
      "qrError": "Der QR-Code konnte nicht heruntergeladen werden. Versuche es erneut.",
      "status": {
        "draft": "Entwurf",
        "active": "Aktiv",
        "suspended": "Ausgesetzt",
        "closed": "Geschlossen"
      }
    },
    "activity": {
      "title": "Transaktionsaktivität",
      "recent": "Letzte Transaktionen",
      "loading": "Transaktionsaktivität wird geladen …",
      "loadErrorTitle": "Aktivität konnte nicht geladen werden",
      "loadErrorBody": "Kein Verlauf wurde geändert. Prüfe deine Verbindung und versuche es erneut.",
      "permissionTitle": "Aktivität nicht verfügbar",
      "permissionBody": "Deine aktuelle Händlerrolle kann diese Aktivität nicht sehen.",
      "emptyTitle": "Noch keine Transaktionsaktivität",
      "emptyBody": "Bestätigte Checkout-Ereignisse erscheinen hier.",
      "count": "{count} Einträge",
      "rewardEffect": "Prämie",
      "details": "Prüfdetails",
      "actor": "Akteur",
      "device": "Checkout-Gerät",
      "requestId": "Anfrage-ID",
      "sharedTillActor": "Geteilte Kasse",
      "systemActor": "Collectie-System",
      "reverses": "Macht Transaktion rückgängig",
      "reversedBy": "Rückgängig gemacht durch Transaktion",
      "reverseAction": "Transaktion rückgängig machen",
      "reversalReason": "Grund der Rückgängigmachung",
      "reversalWarning": "Dadurch werden verknüpfte ausgleichende Hauptbucheinträge erstellt. Die ursprüngliche Transaktion wird nicht gelöscht.",
      "confirmReversal": "Rückgängigmachung bestätigen",
      "reversing": "Ausgleichende Einträge werden erstellt …",
      "reversalComplete": "Die Transaktion wurde mit verknüpften Ausgleichseinträgen rückgängig gemacht.",
      "reversalForbidden": "Deine Rolle kann diese Transaktion nicht rückgängig machen.",
      "reversalConflict": "Diese Transaktion kann nicht mehr rückgängig gemacht werden. Die Aktivität wurde nicht geändert.",
      "reversalOffline": "Das Ergebnis ist unbekannt. Verbinde dich erneut und wiederhole dieselbe Rückgängigmachung.",
      "reversalError": "Die Rückgängigmachung konnte nicht abgeschlossen werden. Wiederhole dieselbe Aktion.",
      "retryReversal": "Dieselbe Rückgängigmachung wiederholen",
      "loadMore": "Ältere Aktivität laden",
      "loadingMore": "Ältere Aktivität wird geladen …",
      "action": {
        "earn": "Stempel gesammelt",
        "redeem": "Prämie eingelöst",
        "adjust": "Anpassung",
        "expire": "Ablauf",
        "reverse": "Rückgängigmachung"
      },
      "status": {
        "committed": "Gebucht",
        "reversed": "Rückgängig gemacht",
        "voided": "Storniert"
      },
      "reason": {
        "cashier_mistake": "Fehler an der Kasse",
        "refund": "Rückerstattung",
        "duplicate": "Doppelte Transaktion",
        "customer_dispute": "Kundenreklamation",
        "operator_correction": "Korrektur durch Operator"
      },
      "reversalNewerEarns": "Storniere zuerst die neueren Stempelkäufe, damit Zwischenprämien zum Kartenfortschritt passen."
    }
  },
  "transaction": {
    "quoteExpired": "Diese Bestätigung ist abgelaufen. Scanne die Karte erneut.",
    "cardUnknown": "Diese Collectie-Karte konnte nicht gelesen werden.",
    "cardRevoked": "Diese Karte wurde ersetzt oder widerrufen.",
    "rewardUnavailable": "Diese Prämie ist nicht mehr verfügbar.",
    "reversalReason": "Grund der Rückgängigmachung",
    "reversed": "Die Transaktion wurde rückgängig gemacht.",
    "walletDelayed": "Die Transaktion ist abgeschlossen. Die Wallet-Karte braucht möglicherweise einen Moment zur Aktualisierung.",
    "dailyLimitReached": "Diese Kundschaft hat heute das Stempellimit für dieses Geschäft erreicht."
  },
  "errors": {
    "generic": "Etwas ist schiefgelaufen.",
    "unauthorized": "Deine Sitzung ist abgelaufen. Melde dich erneut an.",
    "forbidden": "Du hast keine Berechtigung für diese Aktion.",
    "network": "Prüfe deine Verbindung und versuche es erneut.",
    "validation": "Prüfe die hervorgehobenen Felder.",
    "idempotencyMismatch": "Dieser Wiederholungsversuch stimmt nicht mit der ursprünglichen Anfrage überein.",
    "rateLimited": "Zu viele Versuche. Versuche es später erneut."
  },
  "language": {
    "english": "English",
    "traditionalChinese": "繁體中文",
    "german": "Deutsch",
    "choose": "Sprache",
    "current": "Sprache: {language}"
  },
  "demo": {
    "reward": {
      "freeDrink": "Ein Getränk bis 5 €"
    },
    "program": {
      "coffeeClub": "Kaffee-Club",
      "lunchCircle": "Mittagskreis"
    },
    "category": {
      "coffee": "Kaffee",
      "food": "Essen",
      "shops": "Geschäfte"
    },
    "activity": {
      "earn": "Stempel gesammelt",
      "bonus": "App Boost angewendet",
      "reward": "Prämie freigeschaltet",
      "redeem": "Prämie eingelöst"
    },
    "time": {
      "today1432": "Heute · 14:32",
      "yesterday1208": "Gestern · 12:08",
      "jul221744": "22. Juli · 17:44"
    }
  },
  "accessibility": {
    "stampCollected": "Gesammelter Stempel",
    "stampEmpty": "Nicht gesammelter Stempel"
  },
  "official": {
    "meta": {
      "title": "Collectie — Aus Besuchern werden Stammkunden",
      "description": "Ein Kundenbindungsprogramm für Restaurants, Einzelhandel und Malls. Gäste treten in Sekunden über Apple Wallet bei – ohne App, ohne E-Mail, ohne personenbezogene Daten. So pflegen Sie echte Kundenbeziehungen und respektieren zugleich die Privatsphäre.",
      "imageAlt": "Collectie hilft Gastronomie, Einzelhandel und Einkaufszentren, aus Erstbesuchern Stammkunden zu machen."
    },
    "analytics": {
      "label": "Optionale Analyse",
      "title": "Helfen Sie uns, die Website zu verbessern.",
      "body": "Mit Ihrer Einwilligung misst Google Analytics Seitenaufrufe, damit wir diese Website verbessern können. Formularinhalte, URL-Abfrageparameter, Kontodaten und Werbesignale senden wir nie. Analytics bleibt aus, bis Sie es erlauben.",
      "accept": "Analytics erlauben",
      "reject": "Analytics ausgeschaltet lassen",
      "privacy": "Datenschutzerklärung lesen",
      "settings": "Analytics-Einstellungen",
      "statusGranted": "Analytics ist derzeit eingeschaltet.",
      "statusDenied": "Analytics ist derzeit ausgeschaltet."
    },
    "nav": {
      "product": "Loyalty",
      "platform": "Plattform",
      "pricing": "Preise",
      "contact": "Kontakt",
      "primary": "Hauptnavigation",
      "open": "Menü öffnen",
      "close": "Menü schließen",
      "home": "Collectie Startseite"
    },
    "hero": {
      "eyebrow": "Kundenbindung für jedes Geschäft",
      "titleLead": "Aus Erstbesuchern",
      "titleAccent": "werden Stammkunden.",
      "lede": "Collectie ist ein Kundenbindungsprogramm für Restaurants, Cafés, Einzelhandel und Malls. Gäste treten in Sekunden über Apple Wallet bei – ohne App, ohne E-Mail, ohne persönliche Angaben. So bauen Sie echte Beziehungen und wiederkehrende Umsätze auf, ganz ohne Daten, die Ihre Kunden zögern lassen.",
      "primary": "Loyalty entdecken",
      "secondary": "Gesamte Plattform ansehen",
      "artLabel": "Eine Betriebskarte aus der Vogelperspektive, die Kundenweg, Verkaufsfläche, Kasse und Backoffice verbindet",
      "artCore": "Ihr Geschäft",
      "artOrbit": "8 unabhängige Module",
      "scroll": "Plattform entdecken"
    },
    "principle": {
      "eyebrow": "Zuerst Loyalty, alles Weitere bei Bedarf",
      "title": "Verstehen Sie Ihre Kunden. Und holen Sie sie zurück.",
      "body": "Starten Sie mit einem Kundenbindungsprogramm, das jedes Geschäft an einem Tag einführen kann. Ergänzen Sie später Bestellungen, Zahlungen, Tische, Warenbestand und mehr. Alles dreht sich um eine Sache: Ihre Kunden besser zu verstehen und ihnen einen Grund zu geben, wiederzukommen.",
      "keep": "An einem Tag startklar",
      "keepBody": "Führen Sie das Programm für einen Standort ein, ohne Ihre bestehenden Systeme zu ersetzen.",
      "hardware": "Ihre Stammkunden kennen",
      "hardwareBody": "Sehen Sie, wer wiederkommt, wie oft und was beliebt ist – ohne jemals personenbezogene Daten zu speichern.",
      "pace": "Mit sichtbaren Daten steuern",
      "paceBody": "Machen Sie aus jedem Besuch ein klares Signal, auf das Ihr Team reagieren kann, um Wiederbesuche zu fördern."
    },
    "restaurantScene": {
      "eyebrow": "Nah am echten Alltag eines Geschäfts",
      "title": "Jeder Besuch ist eine Chance, eine Beziehung aufzubauen.",
      "body": "Ein Gast kommt, bestellt, bezahlt und geht – und mit Collectie wird dieser Besuch leise Teil einer Beziehung. Der Rhythmus bleibt gleich, ob Sie ein Restaurant, ein Café oder ein Geschäft in einer Mall führen, und Ihr Team arbeitet weiter wie gewohnt.",
      "guest": "Kunden & Verkaufsfläche",
      "kitchen": "Service & Bestand",
      "supply": "Wareneingang & Lieferkette",
      "alt": "Isometrischer Pixel-Art-Schnitt eines warmen Nachbarschaftsrestaurants im Abendservice mit Gastraum, Theke, Küche, Warenbestand und ankommender Lieferung",
      "caption": "Illustrationskonzept · ein Geschäft rund um seine Kunden"
    },
    "loyalty": {
      "eyebrow": "Erstes Produkt · Loyalty",
      "title": "Ein Treueprogramm, dem Gäste in Sekunden beitreten – ganz ohne persönliche Daten.",
      "body": "Kunden scannen Ihren QR-Code im Geschäft und fügen eine Collectie-Karte zu Apple Wallet hinzu. Kein Konto, keine App, keine E-Mail, keine Telefonnummer. Sie gewinnen Stammkunden, ohne personenbezogene Daten zu erheben, die Sie schützen müssten.",
      "wallet": "Keine App, keine persönlichen Daten",
      "walletBody": "Gäste treten direkt über Apple Wallet bei – ohne E-Mail, Telefonnummer oder Konto.",
      "checkout": "Ein Scan beim Bezahlen",
      "checkoutBody": "Ihr Team scannt die Karte und bestätigt den Besuch. Mehr ist es nicht.",
      "truth": "Datenschutz von Anfang an",
      "truthBody": "Prämien werden auf einer anonymen Karte gesammelt, nicht auf einer Person – nichts, wovor Ihre Kunden zurückschrecken.",
      "cardProgram": "Stammgäste",
      "cardReward": "Nächste Belohnung",
      "cardRewardValue": "Dessert des Hauses",
      "cardProgress": "5 von 7 Besuchen",
      "cardMember": "Mitglied 284 916",
      "cardHint": "Beim Bezahlen scannen",
      "flowJoin": "Beitreten",
      "flowJoinBody": "Gast scannt den QR-Code im Restaurant",
      "flowCollect": "Sammeln",
      "flowCollectBody": "Ihr Team bestätigt den Besuch",
      "flowReturn": "Zurückkehren",
      "flowReturnBody": "Die Belohnung bringt Gäste zurück"
    },
    "platform": {
      "eyebrow": "Wachsen Sie in Ihrem Tempo",
      "title": "Zuerst Loyalty. Der Rest kommt, wenn Sie bereit sind.",
      "body": "Beginnen Sie mit dem Treueprogramm, das jedes Geschäft nutzen kann, und ergänzen Sie später Bestellungen, Zahlungen, Tische, Warenbestand und Lieferanten. Verbunden verrät Ihnen jeder Besuch etwas mehr über Ihre Kunden – damit sie wiederkommen. Loyalty ist zuerst verfügbar; die folgenden Module sind geplant.",
      "core": "Collectie Intelligence",
      "coreBody": "Sind Module verbunden, macht der KI-gestützte Kern aus dem Alltag einfache Empfehlungen – welche Stammkunden abwandern, was nachzubestellen ist, was als Nächstes zu versuchen ist. Er berät nur; die Entscheidung bleibt bei Ihrem Team.",
      "intelligenceEyebrow": "KI-gestützter Plattformkern · Geplant",
      "intelligenceMark": "KI",
      "intelligenceForecast": "Bedarf prognostizieren",
      "intelligenceException": "Veränderungen erkennen",
      "intelligenceAction": "Nächsten Schritt vorschlagen",
      "intelligenceGuard": "Ihr Team prüft und genehmigt jede wichtige Aktion.",
      "select": "Modul auswählen",
      "first": "Zuerst verfügbar",
      "planned": "Geplant",
      "pricingBasis": "Preisgrundlage",
      "loyalty": {
        "name": "Loyalty",
        "tagline": "Aus Erstbesuchern werden Stammkunden.",
        "body": "Mitgliedskarte in Apple Wallet, Besuchsstempel und Prämien – ohne App und ohne personenbezogene Daten. Sie legen die Regeln fest, Ihre Stammkunden erledigen den Rest.",
        "price": "Pro aktivem Standort"
      },
      "pos": {
        "name": "POS & Tap to Pay",
        "tagline": "Zahlungen auf Ihrem vorhandenen Gerät annehmen.",
        "body": "Geplanter Checkout für Tap to Pay, Zahlungen und Belege, verknüpft mit jedem Kundenbesuch.",
        "price": "Plattformgebühr + Zahlungsnutzung"
      },
      "orders": {
        "name": "Bestellungen",
        "tagline": "Alle Bestellungen an einem Ort verwalten.",
        "body": "Geplante Bestellverwaltung für Theke, Tisch und Online – für Gastronomie und Einzelhandel.",
        "price": "Pro aktivem Standort"
      },
      "tables": {
        "name": "Tische",
        "tagline": "Jeden Tisch auf einen Blick sehen.",
        "body": "Geplanter Live-Tischstatus, Gästezahlen und Serviceübergaben für das Team auf der Fläche.",
        "price": "Pro aktivem Standort"
      },
      "reservations": {
        "name": "Reservierungen",
        "tagline": "Gäste schon vor der Ankunft willkommen heißen.",
        "body": "Geplante Reservierungen mit Besuchshistorie und Notizen – die Datenschutzkontrolle behalten Sie.",
        "price": "Pro buchbarem Standort"
      },
      "inventory": {
        "name": "Warenbestand",
        "tagline": "Vor der Zusage wissen, was noch verfügbar ist.",
        "body": "Geplante Verfügbarkeit von Waren und Gerichten, die sich mit dem täglichen Betrieb aktualisiert.",
        "price": "Pro Lagerstandort"
      },
      "supply": {
        "name": "Einkauf & Lieferanten",
        "tagline": "Zur richtigen Zeit beim passenden Lieferanten nachbestellen.",
        "body": "Geplanter Einkauf mit Warnungen bei niedrigem Bestand, Lieferantenpreisen, Bestellungen und Wareneingang.",
        "price": "Nach Standort und Einkaufsvolumen"
      },
      "invoice": {
        "name": "Rechnungen",
        "tagline": "Konforme Rechnungen direkt aus jedem Verkauf erstellen.",
        "body": "Geplante Rechnungsstellung nach lokalen Vorgaben, mit dem Checkout verbunden.",
        "price": "Nach Rechtsraum und Dokumentvolumen"
      }
    },
    "pricing": {
      "eyebrow": "Einfache, faire Preise",
      "title": "Mit Loyalty starten. Nur zahlen, was Sie nutzen.",
      "body": "Starten Sie mit dem Treueprogramm und ergänzen Sie Module, sobald sie sich lohnen. Jedes hat eine eigene, klare Preisgrundlage – Sie zahlen nie für Ungenutztes.",
      "loyaltyLabel": "Startpunkt",
      "loyaltyTitle": "Collectie Loyalty",
      "loyaltyBody": "Geschäfte im ersten lokalen Pilotprogramm erhalten Konditionen für Gründungspartner. Die öffentlichen Preise werden später bekannt gegeben.",
      "includedOne": "Mitgliedskarte in Apple Wallet und dauerhafter QR-Code",
      "includedTwo": "Kassenscanner, Prämien und Besuchshistorie – ohne personenbezogene Kundendaten",
      "includedThree": "Programmeinrichtung je aktivem Standort",
      "founding": "Konditionen für Gründungspartner",
      "cta": "Über Ihr Geschäft sprechen",
      "modelLabel": "Preisgestaltung künftiger Module",
      "modelTitle": "Jedes Modul hat eine eigene Preisgrundlage.",
      "modelBody": "Vor der Aktivierung sehen Sie genau, wie ein Modul berechnet wird – zum Beispiel nach Standort, Nutzung, Zahlungsvolumen oder Anzahl der Rechnungen.",
      "note": "Die geplanten Module zeigen unsere Produkt-Roadmap. Verfügbarkeit, Funktionen und Preise können sich vor der Veröffentlichung ändern."
    },
    "contact": {
      "eyebrow": "Erzählen Sie uns von Ihrem Geschäft",
      "title": "Mit Loyalty starten – oder die gesamte Plattform planen.",
      "body": "Sagen Sie uns, was Sie verbessern möchten. Wir zeigen Ihnen die Kundenbindung und besprechen, wie die weiteren Module zu Ihrem Restaurant, Geschäft oder Ihrer Mall passen.",
      "restaurant": "Name des Geschäfts",
      "restaurantPlaceholder": "z. B. Bar Flora",
      "email": "Geschäftliche E-Mail",
      "emailPlaceholder": "sie@ihrgeschaeft.de",
      "city": "Stadt",
      "cityPlaceholder": "Wo sind Sie ansässig?",
      "interest": "Was möchten Sie zuerst besprechen?",
      "interestLoyalty": "Loyalty starten",
      "interestPlatform": "Gesamte Plattform erkunden",
      "interestPilot": "Am lokalen Pilotprogramm teilnehmen",
      "submit": "Produktvorstellung anfragen",
      "submitting": "Anfrage wird gesendet…",
      "privacy": "Wir verwenden diese Angaben nur zur Beantwortung Ihrer Anfrage und löschen den Interessentendatensatz nach 180 Tagen automatisch.",
      "privacyLink": "Datenschutzerklärung lesen",
      "required": "Namen des Geschäfts ergänzen.",
      "restaurantTooLong": "Name des Geschäfts darf höchstens 120 Zeichen haben.",
      "emailRequired": "Geschäftliche E-Mail ergänzen.",
      "emailInvalid": "Gültige E-Mail-Adresse eingeben.",
      "emailTooLong": "Die E-Mail-Adresse darf höchstens 254 Zeichen lang sein.",
      "cityRequired": "Stadt ergänzen.",
      "cityTooLong": "Die Stadt darf höchstens 120 Zeichen lang sein.",
      "submitError": "Ihre Anfrage konnte nicht gespeichert werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
      "rateLimited": "Von dieser Verbindung wurden zu viele Anfragen gesendet. Bitte versuchen Sie es in einer Stunde erneut.",
      "readyTitle": "Anfrage eingegangen.",
      "readyBody": "Wir haben Ihre Anfrage sicher gespeichert. Das Collectie-Team kann Sie über Ihre geschäftliche E-Mail kontaktieren.",
      "again": "Weitere Anfrage senden"
    },
    "footer": {
      "statement": "Langfristige Kundenbeziehungen aufbauen – ohne Daten zu sammeln, die Sie schützen müssten.",
      "availability": "Loyalty zuerst verfügbar · weitere Module in Entwicklung",
      "privacy": "Datenschutz",
      "support": "Support",
      "terms": "Bedingungen",
      "copyright": "© {year} Collectie"
    },
    "privacy": {
      "metaTitle": "Datenschutz — Collectie",
      "metaDescription": "Wie Collectie personenbezogene Daten in der App, Apple Wallet, Händlerwerkzeugen und auf der Website verarbeitet.",
      "skip": "Zur Datenschutzerklärung springen",
      "eyebrow": "Datenschutz · EU/EWR und Taiwan",
      "title": "Ihre Treuehistorie gehört zu Ihnen.",
      "lede": "Diese Erklärung beschreibt, welche Daten Collectie erhebt, warum wir sie benötigen, wer sie erhalten kann und welche Wahlmöglichkeiten Sie haben.",
      "factsLabel": "Angaben zur Datenschutzerklärung",
      "controllerLabel": "Verantwortlicher",
      "controllerName": "Collectie",
      "updatedLabel": "Gültig ab",
      "updatedDate": "26. August 2026",
      "contactLabel": "Datenschutzkontakt",
      "tocLabel": "In dieser Erklärung",
      "summaryLabel": "Kurzfassung",
      "summaryBody": "Collectie verkauft keine personenbezogenen Daten, schaltet keine Drittanbieterwerbung und verfolgt Menschen nicht über Apps oder Websites hinweg. Wir verwenden nur die Daten, die für getrennte Händlerprämien, sichere Konten und aktuelle Apple-Wallet-Pässe erforderlich sind.",
      "emailAction": "Datenschutzfrage stellen",
      "sections": {
        "scope": {
          "title": "Für wen und was diese Erklärung gilt",
          "body": "Collectie ist Verantwortlicher für personenbezogene Daten, die über die Collectie-Kunden-App, Apple-Wallet-Pässe, öffentliche Mitgliedschaftsseiten, Händlerverwaltung und Kassenwerkzeuge, die offizielle Website sowie den Support verarbeitet werden.",
          "coverage": "Ein teilnehmender Händler kann Daten, die er für eigene Treuebedingungen, Kundenservice-, Buchhaltungs- oder Rechtsunterlagen erstellt, selbständig verantworten. Wenn der Händler über die Verwendung entscheidet, informieren Sie sich bitte bei ihm über seine Datenschutzpraxis."
        },
        "data": {
          "title": "Daten, die wir verarbeiten",
          "intro": "Welche Daten betroffen sind, hängt davon ab, wie Sie Collectie nutzen:",
          "identity": "Mitgliedschafts- und Kontodaten: nicht direkt zuordenbare Personen-, Karten- und Mitgliedschaftskennungen; angezeigter Mitgliedscode; Sprache sowie Konto-, Zugangsdaten- oder Passstatus. Kunden müssen vor Erhalt eines Wallet-Passes keine E-Mail-Adresse angeben.",
          "loyalty": "Treueaktivität: Mitgliedschaft bei Händler und Standort, Besuche, Käufe, Fortschritt, Prämien, Anpassungen, Stornierungen und Verfall in einem unveränderlichen Journal. Standardmäßig erfassen wir keinen vollständigen Warenkorb; Kaufbetrag oder Artikelgruppe werden nur gespeichert, wenn eine freigegebene Treueprogrammregel dies tatsächlich benötigt.",
          "wallet": "Apple-Wallet-Daten: Pass-Typ- und Serienkennungen, geschützte Pass-Authentifizierung, Gerätebibliothekskennung, Apple-Push-Token sowie Status der Passerstellung und -aktualisierung.",
          "merchant": "Händlerbetriebsdaten: Name, geschäftliche E-Mail, Rolle, Sitzung und Geräteinformationen autorisierter Händlernutzer sowie Händler-, Standort- und Treueprogrammeinstellungen.",
          "technical": "Technische und Sicherheitsdaten: IP-Adresse und übliche Anfrage-Metadaten, Anfragekennungen, Geräte- oder App-Version sowie Sicherheits- und Diagnoseereignisse. Zugangsdaten, Einmalcodes, Apple-Identitätstoken und Pass-Authentifizierungsdaten werden aus Anwendungsprotokollen entfernt.",
          "support": "Supportdaten: Inhalte und Anhänge, die Sie uns freiwillig senden, sowie Informationen, die zur Untersuchung des Problems nötig sind.",
          "website": "Website-Daten: Eine Anfrage umfasst Restaurantname, geschäftliche E-Mail, Stadt, Interessengebiet, Oberflächensprache, Eingangszeit und Benachrichtigungsstatus. Der Missbrauchsschutz speichert nur einen schlüsselbasierten Hash der Quell-IP, nicht die rohe Adresse. Wenn Sie Analytics erlauben, erhält Google Analytics außerdem Seitenpfad und Referrer ohne Abfrageparameter oder Fragmente, Seitentitel, Oberflächensprache, übliche Browser- und Geräteinformationen, die IP-Adresse bei der Übertragung und eine pseudonyme Cookie-Kennung. Formularinhalte und Kontokennungen werden nie an Analytics gesendet.",
          "minimization": "Wir erheben für diesen Dienst keine Zahlungskartendaten, Gesundheitsdaten, Kontakte oder Werbe-ID. Ein optionaler Standortzugriff berechnet Entfernungen nur auf Ihrem Gerät und wird nicht an die Collectie-API gesendet."
        },
        "uses": {
          "title": "Wofür wir Daten verwenden",
          "intro": "Collectie verwendet personenbezogene Daten ausschließlich für folgende Zwecke:",
          "service": "Mitgliedschaften bereitstellen, serverseitig geführte Guthaben anzeigen, verifizierte Sammel- und Einlösevorgänge verarbeiten und Transaktionsverläufe darstellen.",
          "wallet": "Apple-Wallet-Pässe erstellen, signieren, ausliefern und aktualisieren sowie registrierte Geräte über verfügbare Aktualisierungen informieren.",
          "security": "Nutzer und Händlerpersonal authentifizieren, Missbrauch und doppelte Buchungen verhindern, Betrug untersuchen, Prüfpfade führen und Dienstfehler abgleichen.",
          "support": "Supportanfragen beantworten, Zugänge soweit möglich wiederherstellen und Anträge zu Datenschutzrechten bearbeiten.",
          "contact": "Eine Website-Anfrage entgegennehmen, das Collectie-Team benachrichtigen und an die vom Restaurant angegebene geschäftliche E-Mail antworten. Website-Anfragen werden ohne gesonderte Rechtsgrundlage keiner Marketingliste hinzugefügt.",
          "legal": "Rechtliche, buchhalterische und regulatorische Pflichten erfüllen sowie Rechtsansprüche begründen, ausüben oder verteidigen.",
          "improve": "Zuverlässigkeit überwachen und den Dienst mit aggregierten, niedrig-kardinalen Betriebskennzahlen verbessern – nicht mit Werbeprofilen. Mit Einwilligung messen wir Seitenaufrufe der offiziellen Website, um zu verstehen, welche öffentlichen Informationen nützlich sind."
        },
        "bases": {
          "title": "Rechtsgrundlagen",
          "intro": "Für Personen in der EU oder im EWR richtet sich unsere Rechtsgrundlage nach der jeweiligen Tätigkeit:",
          "contract": "Vertrag: um die angeforderte Mitgliedschaft, den Wallet-Pass, das Konto oder den Händlerdienst bereitzustellen und gewünschte vorvertragliche Schritte durchzuführen.",
          "legitimate": "Berechtigte Interessen: um Collectie sicher und zuverlässig zu betreiben, Missbrauch zu verhindern, Nutzer zu unterstützen und die Dienstleistung zu verstehen – nach Abwägung mit Ihren Rechten.",
          "obligation": "Rechtliche Verpflichtung: um Unterlagen aufzubewahren oder offenzulegen, wenn anwendbares Recht, Buchhaltungsvorschriften oder eine gültige Behördenanfrage dies verlangen.",
          "consent": "Einwilligung: für optionale Website-Analyse, den optionalen Gerätestandort und optionale Kommunikation, soweit eine Einwilligung erforderlich ist. Sie können sie jederzeit mit Wirkung für die Zukunft widerrufen.",
          "taiwan": "In Taiwan verarbeiten wir Daten aufgrund unserer vertraglichen oder vergleichbaren Beziehung zu Ihnen, mit Einwilligung soweit erforderlich und für notwendige, nach dem Personal Data Protection Act zulässige Geschäftszwecke. Notwendige Kennungen sind für Kontoerstellung oder -wiederherstellung und Prämien erforderlich; sofern ein reiner Ansichtsmodus angeboten wird, können Sie ihn ohne Konto nutzen."
        },
        "sharing": {
          "title": "Wer Daten erhält",
          "intro": "Wir legen nur offen, was für den Dienst erforderlich oder gesetzlich vorgeschrieben ist:",
          "merchants": "Teilnehmende Händler erhalten nur Aktivitäten ihrer eigenen Kunden und Standorte. Über Collectie kann kein Händler Kundenaktivitäten eines anderen Händlers einsehen.",
          "cloudflare": "Cloudflare stellt Hosting, Anwendungslaufzeit, Datenbank, Objektspeicher, Warteschlangen und E-Mail-Infrastruktur für den Dienst bereit.",
          "apple": "Apple stellt App Store, Apple Wallet, Apple Push Notification Service und MapKit bereit. Für Apples Verarbeitung gelten dessen eigene Bedingungen und Datenschutzrichtlinie.",
          "google": "Google stellt den optionalen Dienst Google Analytics für die offizielle Website bereit. Das Analytics-Tag wird erst geladen und erhält erst dann einen Seitenaufruf, wenn Sie Analytics erlauben; Google-Werbesignale und Personalisierung bleiben deaktiviert.",
          "law": "Behörden, Berater oder betroffene Parteien können Informationen erhalten, soweit dies zur Rechtsbefolgung, zum Schutz von Personen oder Dienst oder zur Bearbeitung eines Rechtsanspruchs angemessen erforderlich ist.",
          "change": "Bei Umstrukturierung, Finanzierung, Verkauf oder Zusammenschluss von Collectie können relevante Informationen mit dem Unternehmen übertragen werden – mit angemessenem Schutz und, soweit vorgeschrieben, einer Benachrichtigung.",
          "noSale": "Wir verkaufen oder vermieten keine personenbezogenen Daten, teilen sie nicht händlerübergreifend für Werbung und erlauben weder Drittanbieterwerbung noch app-übergreifendes Tracking."
        },
        "transfers": {
          "title": "Internationale Übermittlungen",
          "body": "Collectie nutzt globale Dienstleister. Unsere primäre Cloudflare-D1-Datenbank ist für Westeuropa konfiguriert; Cloudflare, Apple und bei Ihrer Einwilligung in Website-Analytics auch Google können Daten jedoch in anderen Ländern verarbeiten oder weiterleiten, in denen sie tätig sind.",
          "safeguards": "Erfordert eine Übermittlung aus EU oder EWR eine Garantie, stützen wir uns auf einen anwendbaren Angemessenheitsbeschluss, genehmigte vertragliche Schutzmaßnahmen oder einen anderen rechtmäßigen Übermittlungsmechanismus. Weitere Informationen zu den jeweiligen Garantien erhalten Sie auf Anfrage."
        },
        "retention": {
          "title": "Wie lange wir Daten speichern",
          "intro": "Wir speichern personenbezogene Daten nur, solange sie für Dienst, Sicherheit, Streitbeilegung und anwendbare Rechtspflichten nötig sind. Die Dauer hängt von Datensatz und Zweck ab:",
          "active": "Aktive Konto-, Mitgliedschafts-, Zugangs- und Wallet-Datensätze bleiben gespeichert, solange Sie den Dienst nutzen oder sie für eine funktionsfähige und sichere Mitgliedschaft benötigt werden.",
          "deletion": "Nach Abschluss einer Kontolöschung widerruft Collectie Zugangsdaten, schließt Mitgliedschaften und Konten, entfernt gespeicherte Wallet-Passpakete und pseudonymisiert direkte Kontokennungen, sodass sie im normalen Betrieb den gelöschten Nutzer nicht mehr identifizieren.",
          "records": "Transaktions-, unveränderliche Journal- und Prüfdatensätze können nach einer Löschung erhalten bleiben, soweit dies für Guthabenintegrität, Betrugsverhinderung, Streitbeilegung oder Rechtspflichten erforderlich ist. Sobald diese Zwecke entfallen, werden sie gelöscht oder anonymisiert.",
          "support": "Supportnachrichten werden bis zur Lösung und für einen zusätzlich angemessenen Zeitraum für Sicherheit, Streitfälle oder Rechtsbefolgung gespeichert und anschließend gelöscht oder anonymisiert.",
          "analytics": "Die Website speichert Ihre Analytics-Auswahl, bis Sie sie ändern oder die Website-Daten löschen. Wenn Sie Analytics erlauben, laufen die von Collectie gesetzten Google-Analytics-Cookies spätestens 90 Tage nach dem ersten Setzen ab und werden bei späteren Seitenaufrufen nicht verlängert. Analytics-Ereignisdaten unterliegen den für die Analytics-Property konfigurierten Aufbewahrungseinstellungen und werden gelöscht oder anonymisiert, sobald sie nicht mehr benötigt werden.",
          "websiteLeads": "Website-Anfragen und ihre Benachrichtigungsdatensätze werden 180 Tage nach Eingang automatisch gelöscht. Wird aus einer Anfrage eine Kundenbeziehung, wechseln die nötigen Angaben in den jeweiligen Kundendatensatz mit dessen Aufbewahrungsregeln."
        },
        "choices": {
          "title": "Ihre Wahlmöglichkeiten",
          "intro": "Mehrere Teile des Dienstes können Sie selbst steuern:",
          "account": "Nutzen Sie, soweit angeboten, den reinen Ansichtsmodus, verwalten Sie Kontodaten in der App oder starten Sie die Löschung unter Profil → Datenschutz und Daten.",
          "location": "Lehnen Sie den optionalen Standortzugriff ab. Die Entfernungsanzeige entfällt, Mitgliedschaften und Prämien funktionieren weiter.",
          "wallet": "Entfernen Sie einen Pass jederzeit aus Apple Wallet. Dadurch allein werden Ihr Collectie-Konto oder Treuedaten nicht gelöscht; nutzen Sie dafür die Löschfunktion in der App oder kontaktieren Sie uns.",
          "website": "Die offizielle Website speichert Ihre Sprach- und Analytics-Auswahl lokal im Browser. Google Analytics bleibt aus und das Tag wird nicht geladen, bis Sie es erlauben. Über die Analytics-Einstellungen im Footer können Sie Analytics jederzeit erlauben oder widerrufen; beim Widerruf werden Collectie-Analytics-Cookies entfernt. Angaben im Kontaktformular sind freiwillig; alternativ können Sie den Support per E-Mail kontaktieren. Lokale Einstellungen können Sie im Browser löschen.",
          "marketing": "Collectie versendet derzeit keine Marketingnachrichten an Verbraucher. Sollte sich dies ändern, enthalten optionale Nachrichten die gesetzlich erforderlichen Einwilligungs- und Abmeldemöglichkeiten."
        },
        "rights": {
          "title": "Ihre Datenschutzrechte",
          "intro": "Ihre Rechte richten sich nach Ihrem Wohnort und können gesetzlichen Ausnahmen unterliegen:",
          "eu": "EU/EWR: Sie können Auskunft, Berichtigung, Löschung, Einschränkung oder Übertragbarkeit verlangen oder Widerspruch einlegen; eine Einwilligung widerrufen; und sich bei Ihrer Datenschutzaufsichtsbehörde beschweren.",
          "taiwan": "Taiwan: Nach dem Personal Data Protection Act können Sie Auskunft oder Einsicht, eine Kopie, Ergänzung oder Berichtigung sowie die Einstellung von Erhebung, Verarbeitung oder Nutzung und die Löschung verlangen.",
          "request": "Schreiben Sie zur Ausübung eines Rechts an contact@collectie.io. Beschreiben Sie das betroffene Konto oder die Mitgliedschaft und Ihren Antrag, senden Sie aber keine Passwörter, Einmalcodes, vollständigen QR- oder Kartenzugangsdaten, Pass-Authentifizierung, API-Schlüssel oder privaten Schlüssel. Vor der Bearbeitung können wir Ihre Identität prüfen. EU-/EWR-Anträge beantworten wir normalerweise innerhalb eines Monats; Anträge in Taiwan innerhalb der gesetzlich vorgeschriebenen Fristen.",
          "complaint": "Kontaktieren Sie möglichst zuerst uns, damit wir den Sachverhalt untersuchen können. Sie können sich auch direkt bei der zuständigen Datenschutz- oder Privatsphärenbehörde Ihres Landes oder Ihrer Region beschweren."
        },
        "security": {
          "title": "Wie wir Daten schützen",
          "body": "Wir setzen Transportverschlüsselung, rollenbasierte Zugriffe, Trennung von Händler-Mandanten, geschützte Authentifizierungsdaten, idempotente Transaktionskontrollen, unveränderliche Journale, Prüfereignisse und Protokollbereinigung ein. Zugriff auf Produktionssysteme und Signaturmaterial ist auf autorisierte Zwecke beschränkt.",
          "limits": "Kein Internetdienst kann absolute Sicherheit garantieren. Wenn Sie vermuten, dass Ihr Collectie-Konto oder Ihre Daten gefährdet sind, kontaktieren Sie zeitnah contact@collectie.io und fügen Sie der Nachricht keine Zugangsdaten bei."
        },
        "changes": {
          "title": "Änderungen und Kontakt",
          "body": "Wir können diese Erklärung aktualisieren, wenn sich Dienst, Anbieter oder Rechtslage ändern. Wir veröffentlichen die neue Fassung hier, passen das Gültigkeitsdatum an und informieren zusätzlich im Dienst, wenn eine Änderung Ihre Privatsphäre wesentlich betrifft.",
          "contact": "Für Datenschutzfragen oder -anträge schreiben Sie an contact@collectie.io. Collectie ist das für diese Erklärung verantwortliche Unternehmen."
        }
      }
    },
    "support": {
      "metaTitle": "Support — Collectie",
      "metaDescription": "Hilfe zu Collectie-Mitgliedschaften, Prämien, Apple-Wallet-Pässen, Konten und Händlerwerkzeugen.",
      "skip": "Zum Collectie-Support springen",
      "eyebrow": "Collectie-Support",
      "title": "Bringen wir Sie zurück zu Ihren Prämien.",
      "lede": "Hilfe für Kunden mit Collectie-App oder Apple Wallet und für Händlerteams, die das Treueprogramm an der Kasse betreiben.",
      "contactKicker": "Kontakt",
      "contactTitle": "Sagen Sie uns, was passiert ist.",
      "contactBody": "Senden Sie eine klare Nachricht mit den unten genannten Angaben. Nutzen Sie die Supportadresse für Produktprobleme und die Datenschutzadresse für Anträge zu Ihren Datenrechten.",
      "emailLabel": "Produkt- und Kontosupport",
      "privacyLabel": "Datenschutzanträge",
      "safetyKicker": "Zugangsdaten geheim halten",
      "safetyTitle": "Was nie in eine E-Mail gehört",
      "safetyBody": "Senden Sie niemals ein Passwort, einen Einmalcode, vollständige QR- oder Kartenzugangsdaten, Pass-Authentifizierung, API-Schlüssel, Signaturzertifikate oder private Schlüssel. Collectie wird Sie nie bitten, diese per E-Mail zu schicken.",
      "prepareKicker": "Vor Ihrer E-Mail",
      "prepareTitle": "Vier Angaben helfen uns, schneller zu untersuchen.",
      "prepare": {
        "device": "Gerätemodell, iOS- oder Browser-Version und, falls verfügbar, Version der Collectie-App.",
        "merchant": "Betroffener Händler und Standort, ohne Informationen über andere Personen zu teilen.",
        "time": "Ungefähre Uhrzeit, Zeitzone und die unmittelbar zuvor ausgeführte Aktion.",
        "screenshot": "Ein Screenshot, auf dem Mitgliedscodes, QR-Codes, E-Mail-Adressen, Token und andere Zugangsdaten abgedeckt oder ausgeschnitten sind."
      },
      "topicsKicker": "Häufige Themen",
      "topicsTitle": "Beginnen Sie mit dem passenden Kontext.",
      "topics": {
        "wallet": {
          "title": "Apple-Wallet-Pass",
          "body": "Lässt sich ein Pass nicht hinzufügen oder aktualisieren, lassen Sie ihn installiert, prüfen Sie die Internetverbindung und nennen Sie uns den ausstellenden Händler. Der Server führt das Guthaben; ein vorübergehend veralteter Pass ändert den zugrunde liegenden Prämiendatensatz nicht."
        },
        "rewards": {
          "title": "Fehlender Besuch oder fehlende Prämie",
          "body": "Nennen Sie Händler, Standort, ungefähre Kaufzeit und die erwartete Anzeige. Prämien bleiben nach Händler getrennt; nur der betreffende Händler kann einen Kauf bestätigen oder stornieren."
        },
        "account": {
          "title": "Neues oder verlorenes Gerät",
          "body": "Nutzen Sie den in der App gezeigten Wiederherstellungsweg. Scheitert der Zugriff weiter, kontaktieren Sie uns, bevor Sie zusätzliche Konten anlegen, damit wir die sicherste verfügbare Möglichkeit finden können."
        },
        "deletion": {
          "title": "Konto löschen",
          "body": "Öffnen Sie in der App Profil → Datenschutz und Daten → Konto löschen. Haben Sie keinen App-Zugriff, schreiben Sie dem Support mit dem Wunsch zur Kontolöschung; wir prüfen den Antrag vor der Umsetzung."
        },
        "merchant": {
          "title": "Händlerkasse oder -verwaltung",
          "body": "Nennen Sie bei Problemen mit Anmeldung, Einmalcode, Geräteverknüpfung, Widerruf oder Stornierung Händler, Standort und Gerätebezeichnung – niemals jedoch Code, Sitzungsdaten oder Signaturmaterial."
        }
      },
      "responseKicker": "Wie es weitergeht",
      "responseTitle": "Eine Person prüft Ihre Anfrage.",
      "responseBody": "Wir bemühen uns, an Werktagen so bald wie vernünftig möglich zu antworten. Anträge zu Datenschutzrechten folgen den in unserer Erklärung genannten gesetzlichen Fristen. Setzen Sie bei einem vermuteten Sicherheitsproblem „Security“ in den Betreff, ohne Zugangsdaten beizufügen.",
      "privacyAction": "Datenschutzerklärung lesen"
    },
    "terms": {
      "metaTitle": "Nutzungsbedingungen — Collectie",
      "metaDescription": "Bedingungen für Collectie-Mitgliedschaften, Prämien, Apple-Wallet-Pässe, Kundenkonten und Händlerwerkzeuge.",
      "skip": "Zu den Nutzungsbedingungen springen",
      "eyebrow": "Nutzungsbedingungen · EU/EWR und Taiwan",
      "title": "Klare Regeln für gesammelte Vorteile.",
      "lede": "Diese Bedingungen regeln die Nutzung der Collectie-Treuedienste, Kunden-App, Apple-Wallet-Pässe, öffentlichen Mitgliedschaftsseiten und Händlerwerkzeuge.",
      "factsLabel": "Angaben zu den Nutzungsbedingungen",
      "providerLabel": "Diensteanbieter",
      "providerName": "Collectie",
      "updatedLabel": "Gültig ab",
      "updatedDate": "18. August 2026",
      "contactLabel": "Supportkontakt",
      "tocLabel": "In diesen Bedingungen",
      "summaryLabel": "Die wesentliche Vereinbarung",
      "summaryBody": "Collectie stellt die Technik bereit, die händlerspezifische Treueaktivitäten erfasst. Jeder Händler verwaltet sein eigenes Programm und bleibt für Produkte, Dienstleistungen und Prämienversprechen verantwortlich. Zwingende Verbraucherrechte bleiben stets bestehen.",
      "emailAction": "Frage zu diesen Bedingungen stellen",
      "sections": {
        "agreement": {
          "title": "Zustimmung und Berechtigung",
          "body": "Indem Sie einen Collectie-Dienst aufrufen oder nutzen, stimmen Sie diesen Bedingungen und unserer Datenschutzerklärung zu. Nutzen Sie Händlerwerkzeuge für eine Organisation, bestätigen Sie, dass Sie für sie handeln dürfen. Wenn Sie nicht zustimmen, nutzen Sie den Dienst nicht.",
          "eligibility": "Sie dürfen Collectie nur nutzen, wenn Sie diese Vereinbarung rechtswirksam eingehen können. Verlangt das örtliche Recht die Zustimmung eines Elternteils oder einer sorgeberechtigten Person, ist die Nutzung nur mit dieser Zustimmung erlaubt."
        },
        "service": {
          "title": "Was Collectie bereitstellt",
          "intro": "Collectie stellt Software und Infrastruktur für Treuemitgliedschaften bereit:",
          "membership": "Ein öffentlicher Shop-QR-Code kann eine Mitgliedschaft anlegen oder öffnen. Er beweist niemals einen Kauf und vergibt allein keinen Wert; eine berechtigte Transaktion muss getrennt verifiziert werden.",
          "separation": "Mitgliedschaften, Fortschritt und Prämien bleiben nach Händler getrennt. Sie können über Collectie nicht übertragen, zusammengeführt oder bei einem anderen Händler eingelöst werden.",
          "availability": "Funktionen können nach Händler, Standort, Gerät, Sprache oder Pilotphase variieren. Wir können Funktionen verbessern oder ersetzen, wahren dabei aber anwendbare Rechte und verbindliche Datensätze.",
          "noPayment": "Soweit ein gesonderter schriftlicher Dienst nichts anderes ausdrücklich bestimmt, ist Collectie Loyalty weder Zahlungsdienst noch Bankkonto, Guthabenprodukt oder Kassensystem und verwahrt kein Geld von Ihnen."
        },
        "accounts": {
          "title": "Konten und Zugangsdaten",
          "intro": "Sie sind für einen sorgfältigen Umgang mit Konto und Zugangsdaten verantwortlich:",
          "accuracy": "Machen Sie auf Anfrage richtige und aktuelle Angaben. Geben Sie sich nicht als eine andere Person aus und erstellen Sie keine Konten, um einen Händler oder Collectie zu täuschen.",
          "security": "Schützen Sie Gerät, Pass, Kontozugang und Wiederherstellungsinformationen. Informieren Sie den Support unverzüglich bei Verdacht auf Verlust, unbefugten Zugriff oder Missbrauch.",
          "devices": "Ein physisches Gerät ist nicht Ihre Identität. Browser-, Wallet-, Karten- und App-Datensätze sind einer Person zugeordnete Zugangsmittel und können aus Sicherheitsgründen widerrufen oder ersetzt werden.",
          "recovery": "Eine Wiederherstellung hängt von verfügbaren, verifizierten Informationen und Zugangsmitteln ab. Können wir die Berechtigung nicht sicher feststellen, dürfen wir sie ablehnen oder verzögern."
        },
        "rewards": {
          "title": "Besuche, Fortschritt und Prämien",
          "intro": "Die händlerspezifischen Programmregeln bestimmen, ob eine Transaktion berechtigt ist und wie eine Prämie funktioniert:",
          "merchantRules": "Der Händler legt Regeln zu Sammeln, Einlösen, Verfall, Berechtigung und Verfügbarkeit fest und muss Kunden zusätzliche Bedingungen zugänglich machen.",
          "server": "Maßgeblich ist der Serverdatensatz von Collectie. App-Anzeige oder Wallet-Pass sind eine Abbildung und können kurzzeitig veraltet sein, während eine Aktualisierung ausgeliefert wird.",
          "corrections": "Berechtigte Sammel-, Bonus-, Einlöse-, Verfalls-, Anpassungs- und Stornoaktivitäten werden als Journaleinträge erfasst. Fehler werden durch eine prüfbare Anpassung oder Stornierung korrigiert, nicht durch heimliches Löschen verbindlicher Historie.",
          "noValue": "Soweit anwendbares Recht oder ausdrückliche Händlerbedingungen nichts anderes bestimmen, sind Treuefortschritt und Prämien Werbevorteile ohne Barwert, werden nicht verzinst und dürfen nicht verkauft oder übertragen werden."
        },
        "wallet": {
          "title": "Apple Wallet und App Store",
          "body": "Ein Apple-Wallet-Pass zeigt von Collectie bereitgestellte Mitgliedschaftsinformationen. Er ist kein eigenständiges Konto und kein Nachweis dafür, dass ein Kauf stattgefunden hat.",
          "apple": "Download und Nutzung der iOS-App unterliegen außerdem den anwendbaren Apple-App-Store-Bedingungen und Apples Standard-Endnutzer-Lizenzvertrag, sofern in App Store Connect kein eigener EULA bereitgestellt wird.",
          "updates": "Wallet-Aktualisierungen benötigen kompatible Apple-Dienste, ein unterstütztes Gerät und Netzwerkverfügbarkeit. Eine verzögerte Anzeige ändert den serverseitig geführten Journaldatensatz nicht.",
          "removal": "Das Entfernen eines Wallet-Passes löscht Ihr Collectie-Konto oder Ihre Treuehistorie nicht automatisch. Nutzen Sie für eine Löschung die Funktion in der App oder kontaktieren Sie den Support."
        },
        "acceptable": {
          "title": "Zulässige Nutzung",
          "intro": "Sie dürfen Collectie nicht missbrauchen oder anderen dabei helfen. Insbesondere dürfen Sie nicht:",
          "law": "Den Dienst rechtswidrig oder zur Verletzung der Rechte anderer nutzen.",
          "access": "Ohne Berechtigung auf ein Konto, einen Händler, Standort, eine API, ein System oder Daten zugreifen oder Berechtigungs- und Sicherheitskontrollen umgehen.",
          "interference": "Den Dienst stören, überlasten, prüfen, automatisiert auslesen oder zurückentwickeln, außer soweit anwendbares Recht dies ausdrücklich in begrenztem Umfang erlaubt.",
          "fraud": "Käufe, Mitgliedscodes, QR-Codes, Pässe, Prämien, Stornierungen oder andere Treueaktivitäten fälschen oder manipulieren.",
          "credentials": "Passwörter, Einmalcodes, rohe Karten- oder QR-Zugangsdaten, Pass-Authentifizierung, Sitzungstoken, API-Schlüssel, Zertifikate oder private Schlüssel weitergeben."
        },
        "content": {
          "title": "Inhalte und geistiges Eigentum",
          "intro": "Diese Bedingungen übertragen kein Eigentum am Dienst oder an Drittinhalten:",
          "collectie": "Collectie und seine Lizenzgeber behalten alle Rechte an Software, Design, Marke und Dienstmaterialien. Wir gewähren Ihnen ein begrenztes, persönliches, widerrufliches und nicht übertragbares Recht zur vertragsgemäßen Nutzung.",
          "merchant": "Händler bleiben für Namen, Logos, Angebote und Programminhalte verantwortlich. Diese dürfen außerhalb des Dienstes nicht ohne Erlaubnis des jeweiligen Rechteinhabers kopiert oder genutzt werden.",
          "feedback": "Senden Sie freiwillig Produktfeedback, darf Collectie es unentgeltlich zum Betrieb und zur Verbesserung des Dienstes verwenden. Fügen Sie keine vertraulichen Informationen oder personenbezogenen Daten anderer bei."
        },
        "merchants": {
          "title": "Teilnehmende Händler",
          "body": "Teilnehmende Händler sind unabhängige Unternehmen. Sie – nicht Collectie – verkaufen Waren und Dienstleistungen, verifizieren Käufe, bestimmen Programmregeln, erfüllen Prämien, bearbeiten Produktbeschwerden und halten die für ihr Geschäft geltenden Gesetze ein.",
          "contract": "Eine gesonderte Händlerdienstvereinbarung regelt die Nutzung durch eine Händlerorganisation und kann kommerzielle, Support- und Datenverarbeitungsbedingungen enthalten. Widerspricht sie diesen öffentlichen Bedingungen für die Händlernutzung, geht die unterzeichnete Vereinbarung für diese Organisation vor."
        },
        "suspension": {
          "title": "Beendigung oder Aussetzung",
          "body": "Zugriff kann eingeschränkt oder ausgesetzt werden, wenn dies zum Schutz von Nutzern, Händlern oder Collectie, zur Untersuchung vermuteten Missbrauchs, zur Rechtsbefolgung, für ein Sicherheitsproblem oder bei wesentlicher Vertragsverletzung angemessen erforderlich ist. Soweit passend, erklären wir den Grund und bieten eine Kontaktmöglichkeit.",
          "user": "Sie können Collectie jederzeit nicht mehr nutzen und, soweit in der App verfügbar, die Kontolöschung starten.",
          "collectie": "Collectie kann eine Funktion oder den Dienst, soweit praktikabel, mit angemessener Frist einstellen. Gesetzlich zwingende Erstattungen oder Rechtsbehelfe bleiben verfügbar.",
          "records": "Schließung oder Aussetzung löscht keine Transaktions-, unveränderlichen Journal- oder Prüfdatensätze, die für Guthabenintegrität, Sicherheit, Streitfälle oder Rechtspflichten benötigt werden; unsere Datenschutzerklärung beschreibt ihre Verarbeitung."
        },
        "disclaimers": {
          "title": "Leistungszusagen und Haftungsausschlüsse",
          "body": "Wir erbringen Collectie mit angemessener Sorgfalt und Fachkunde. Soweit gesetzlich zulässig, versprechen wir keinen stets unterbrechungs- oder fehlerfreien Dienst, keine Kompatibilität mit jedem Gerät und nicht, dass ein Händler ein Programm, Produkt oder eine Prämie verfügbar hält.",
          "mandatory": "Diese Bedingungen schließen keine Gewährleistung, Garantie, Abhilfe oder sonstigen Verbraucherrechte aus, deren Ausschluss nach anwendbarem Recht unzulässig ist."
        },
        "liability": {
          "title": "Verantwortung für Schäden",
          "body": "Collectie haftet nach den Regeln und Rechtsbehelfen des anwendbaren Rechts für Schäden, die vernünftigerweise vorhersehbar und unmittelbar durch unsere Vertragsverletzung oder mangelnde angemessene Sorgfalt und Fachkunde verursacht wurden.",
          "exclusions": "Soweit gesetzlich zulässig, haftet Collectie nicht für mittelbare oder unvorhersehbare Schäden, Händlerwaren oder -dienste, die Weigerung eines Händlers, eine Prämie zu erfüllen, Schäden durch Ihren Missbrauch oder unzureichenden Schutz von Zugangsdaten sowie Ereignisse außerhalb unserer angemessenen Kontrolle.",
          "mandatory": "Wir schließen Haftung nicht aus oder begrenzen sie nicht, wenn dies rechtswidrig wäre, insbesondere bei Betrug, Vorsatz, soweit anwendbar grober Fahrlässigkeit oder fahrlässig verursachtem Tod oder Personenschaden. Zwingende Verbraucherrechtsbehelfe bleiben unberührt."
        },
        "law": {
          "title": "Anwendbares Recht und Streitfälle",
          "body": "Diese Bedingungen entziehen Verbrauchern keine zwingenden Schutzrechte nach dem Recht ihres gewöhnlichen Aufenthalts. Recht und Gerichtsstand einer Händlerorganisation bestimmen sich nach ihrer gesonderten Händlervereinbarung.",
          "resolution": "Kontaktieren Sie zuerst den Support, damit wir eine Lösung versuchen können. Sie können weiterhin jedes zuständige Gericht, jede Behörde, Verbraucherstelle oder jedes gesetzlich verfügbare Streitverfahren nutzen; diese Bedingungen verlangen keine individuelle Schiedsgerichtsbarkeit."
        },
        "changes": {
          "title": "Änderungen dieser Bedingungen",
          "body": "Wir können diese Bedingungen wegen Änderungen an Dienst, Sicherheit, Recht oder Betrieb aktualisieren. Wir veröffentlichen die neue Fassung, ändern das Gültigkeitsdatum und informieren bestehende Nutzer bei wesentlichen Änderungen angemessen im Voraus, sofern eine dringende Rechts- oder Sicherheitsänderung kein schnelleres Handeln erfordert.",
          "continued": "Die neue Fassung gilt ab dem angegebenen Datum. Wenn Sie nicht zustimmen, können Sie die Nutzung beenden und Kontolöschung verlangen; zuvor entstandene Rechte und Pflichten bleiben bestehen."
        },
        "contact": {
          "title": "Kontakt",
          "body": "Fragen, Beschwerden oder Mitteilungen zu diesen Bedingungen senden Sie an contact@collectie.io. Collectie ist das Unternehmen, das den hier beschriebenen Dienst bereitstellt.",
          "privacy": "Informationen zu personenbezogenen Daten und zur Ausübung von Datenschutzrechten finden Sie in unserer Datenschutzerklärung oder unter contact@collectie.io."
        }
      }
    },
    "legal": {
      "privacyTitle": "Datenschutzhinweis",
      "termsTitle": "Nutzungsbedingungen",
      "draft": "Lokaler Designentwurf",
      "notice": "Dieser Inhalt ist ein Entwurf für die Designprüfung und muss vor der Veröffentlichung rechtlich geprüft werden.",
      "privacyBody": "Diese lokale Vorschau sendet oder speichert das Kontaktformular nicht. Bevor die öffentliche Website personenbezogene Daten erfasst, muss sie den Betreiber, die Rechtsgrundlage, Dienstleister, Aufbewahrungsfristen, den Kontakt für Datenschutzrechte und alle regional vorgeschriebenen Angaben nennen.",
      "termsBody": "Diese lokale Vorschau erstellt weder ein Händlerkonto noch einen Vertrag oder eine Leistungszusage. Vor der Veröffentlichung müssen Betreiber, Leistungen, Pilotbedingungen, Zahlungen, Haftung und anwendbares Recht juristisch geprüft werden.",
      "back": "Zurück zur Website"
    },
    "notFound": {
      "eyebrow": "404 · Tisch nicht gefunden",
      "title": "Diese Seite wurde nicht gefunden.",
      "body": "Die Adresse hat sich möglicherweise geändert oder die Seite ist noch nicht verfügbar.",
      "back": "Zurück zu Collectie"
    }
  },
  "app": {
    "title": "Collectie-App holen",
    "lede": "Deine Wallet-Karte funktioniert weiter. Die App zeigt die Prämien aller Geschäfte an einem Ort, deine Aktivität und einen sicheren Weg, deine Karte auf ein neues Telefon zu übertragen.",
    "cardKeeps": "Nutze deine Wallet-Karte weiter",
    "cardKeepsBody": "An der Kasse ändert sich nichts: Zeige die Karte, das Geschäft scannt sie und deine Stempel werden aktualisiert.",
    "comingSoonTitle": "Noch nicht im App Store",
    "comingSoonBody": "Die Collectie-App befindet sich im Pilottest. Deine Prämien werden in der Zwischenzeit auf deiner Karte gespeichert.",
    "download": "Im App Store laden",
    "back": "Zurück zu Collectie"
  },
  "admin": {
    "pageTitle": "Collectie Admin",
    "admin": "Admin",
    "home": "Collectie Admin-Startseite",
    "internal": "Interne Verwaltung",
    "authTitle": "Jeden Betrieb im Blick.",
    "authBody": "Neue Betriebe einrichten, Mitgliederaktivität verstehen und bei der Nutzung von Collectie helfen.",
    "authNote": "Für das Collectie-Team. Zugang nur für zugelassene Administratoren.",
    "secureAccess": "E-Mail-Verifizierung",
    "signIn": "Bei Admin anmelden",
    "emailHelp": "Zugelassene Adressen erhalten einen sechsstelligen Code. Er gilt fünf Minuten.",
    "codeTitle": "Posteingang prüfen",
    "codeHelp": "Code aus der E-Mail eingeben. Jeder Code kann einmal verwendet werden.",
    "resend": "Andere E-Mail verwenden oder neuen Code anfordern",
    "working": "Bitte warten…",
    "merchants": "Betriebe",
    "directoryBody": "Ein gemeinsamer Arbeitsbereich für Einrichtung, Mitgliederwachstum und Support.",
    "onboard": "Betrieb hinzufügen",
    "search": "Suchen",
    "searchPlaceholder": "Betriebsname oder URL-Kürzel",
    "refresh": "Aktualisieren",
    "loading": "Arbeitsbereich wird geladen…",
    "retry": "Erneut versuchen",
    "merchantCount": "Betriebe: {count}",
    "measuredAt": "Aktualisiert: {time}",
    "emptyTitle": "Keine Betriebe gefunden",
    "emptyBody": "Anderen Suchbegriff verwenden oder einen Betrieb hinzufügen.",
    "merchant": "Betrieb",
    "members": "Mitglieder gesamt",
    "newMembers": "Neue Mitglieder",
    "activation": "Aktivierung durch Erstkauf",
    "retention": "Kundenbindung",
    "lastLogin": "Letzte Betriebsanmeldung",
    "sample": "{count} von {total} Mitgliedern",
    "unavailable": "–",
    "never": "–",
    "previous": "Zurück",
    "next": "Weiter",
    "page": "Seite {page}",
    "merchantDetail": "Betriebsdetails",
    "close": "Details schließen",
    "activeMembers": "Kaufende Mitglieder",
    "lastPurchase": "Letzter verifizierter Kauf",
    "onboardedAt": "Erstellt: {time}",
    "listed": "In Entdecken sichtbar",
    "unlisted": "Nicht in Entdecken sichtbar",
    "status_active": "Aktiv",
    "status_draft": "Entwurf",
    "status_suspended": "Gesperrt",
    "status_closed": "Geschlossen",
    "supportTitle": "Betriebssupport",
    "supportHelp": "Verwaltungsbereich für bis zu 15 Minuten öffnen. Änderungen gelten für den Betrieb und werden dir zugeordnet.",
    "reason": "Grund für den Zugriff",
    "reasonHelp": "8–300 Zeichen. Supportaufgabe ohne personenbezogene oder vertrauliche Angaben beschreiben.",
    "openSupport": "Betriebsbereich öffnen",
    "supportBanner": "Support für {merchant}",
    "supportExpiry": "Zugriff endet um {time}. Änderungen werden deiner Admin-Identität zugeordnet.",
    "endSupport": "Support beenden und zurück",
    "supportAttribution": "Du arbeitest als Collectie-Administrator. Diese Sitzung meldet dich nicht als Betriebsinhaber an.",
    "managementNavigation": "Betriebsverwaltung",
    "supportExpired": "Supportzugriff abgelaufen. Bei Bedarf eine neue Sitzung öffnen.",
    "definitions": "So werden die Kennzahlen berechnet",
    "activationDefinition": "Aktivierung: Mitglieder mit mindestens einem verifizierten Sammelkauf, geteilt durch alle Mitgliedschaften dieses Betriebs. Rückgängig gemachte Käufe zählen nicht.",
    "retentionDefinition": "30-Tage-Bindung: Mitglieder mit erneutem verifiziertem Sammelkauf zwischen 24 Stunden und 30 Tagen nach dem ersten. Nur vollständig abgelaufene 30-Tage-Fenster zählen zum Nenner. Stichprobengrößen stehen neben der Quote.",
    "loginDefinition": "Letzte Anmeldung: letzte erfolgreiche Betriebsanmeldung eines Nutzers mit aktueller Rolle bei diesem Betrieb, auch bei mehreren Betrieben. Admin-Support zählt nicht. Zeiten verwenden die Browser-Zeitzone.",
    "scopeDefinition": "Mitgliedschaften zählen ab ihrer automatischen Erstellung vor der Wallet-Aktion. Die Bindungsrate basiert auf vollständig beobachteten historischen Kohorten, nicht auf einem Monatsvergleich.",
    "back": "Zurück zu Betrieben",
    "dismiss": "Schließen",
    "footer": "Collectie · Betriebsverwaltung",
    "errorNetwork": "Verbindung fehlgeschlagen. Verbindung prüfen und erneut versuchen.",
    "errorRate": "Zu viele Code-Anfragen. Nach 15 Minuten erneut versuchen.",
    "errorCode": "Code konnte nicht bestätigt werden. Prüfen oder neuen Code anfordern.",
    "errorSession": "Admin-Sitzung beendet. Zum Fortfahren erneut anmelden.",
    "errorPermission": "Diese Aktion ist mit deinem aktuellen Zugriff nicht verfügbar.",
    "errorSupportActive": "Es besteht bereits eine Support-Sitzung. Seite aktualisieren und diese beenden, bevor ein anderer Betrieb geöffnet wird.",
    "errorConflict": "Diese Anfrage steht im Konflikt mit einer früheren Aktion. Aktualisieren und aktuellen Stand vor erneutem Versuch prüfen.",
    "errorGeneric": "Aktion konnte nicht abgeschlossen werden. Angaben prüfen und erneut versuchen.",
    "onboardTitle": "Betrieb hinzufügen",
    "onboardBody": "Betrieb, ersten Standort und Inhaberzugang gemeinsam erstellen. Anschließend im Betriebssupport beim Einrichten des Treueprogramms helfen.",
    "createMerchant": "Betrieb erstellen",
    "joinVisits": "QR-/Link-Aufrufe",
    "joinCompletions": "Abgeschlossene Beitritte",
    "joinConversion": "Beitrittsrate",
    "visitSample": "{count} von {total} Aufrufen",
    "joinTrackingSince": "Aufrufe werden seit {time} erfasst. Frühere Aufrufe sind nicht verfügbar.",
    "joinDefinition": "Ein Aufruf beginnt, wenn die Beitrittsseite geladen ist und die Sitzung vorbereitet wird. Neuladen und Sprachwechsel im selben Tab und Standort zählen innerhalb von 30 Minuten einmal. QR- und direkte Links sind enthalten; Kamera-Scans und einzelne Personen lassen sich nicht bestimmen. Ein Beitritt zählt, wenn eine neue Mitgliedschaft innerhalb dieses Zeitfensters eine erfolgreiche Wallet-Download-Antwort erhält. Bestehende Mitglieder, Wiederholungen und fehlgeschlagene Downloads zählen nicht als Beitritte. Das Speichern in Wallet ist damit nicht bestätigt. Der Nenner umfasst die in den letzten 30 Tagen begonnenen Aufrufe, auch noch laufende. Blockierter Browserspeicher und Erfassungsfehler können Lücken verursachen.",
    "backToShops": "Zurück zur Liste",
    "selectShopTitle": "Shop auswählen und Kennzahlen ansehen",
    "selectShopBody": "Wähle einen Shop aus der Liste. Mitgliederaktivität und Beitrittskennzahlen erscheinen hier.",
    "memberTotal": "{count} Mitglieder",
    "metricHelp": "Berechnung von {metric}",
    "membersDefinition": "Alle für diesen Händler angelegten Mitgliedschaften, einschließlich automatisch vor der Wallet-Aktion erstellter Mitgliedschaften. Dies bestätigt nicht, dass die Karte in Wallet gespeichert wurde.",
    "newMembersDefinition": "In den letzten 30 Tagen für diesen Händler angelegte Mitgliedschaften, einschließlich automatischer Erstellung vor der Wallet-Aktion.",
    "activeMembersDefinition": "Unterschiedliche Mitglieder mit mindestens einem verifizierten Sammelkauf bei diesem Händler in den letzten 30 Tagen. Stornierte Käufe sind ausgeschlossen.",
    "lastPurchaseDefinition": "Der letzte verifizierte Sammelkauf bei diesem Händler, ohne stornierte Käufe. Zeiten verwenden die Zeitzone des Browsers.",
    "joinVisitsDefinition": "Aufrufe der Beitrittsseite über QR- oder Direktlinks in den letzten 30 Tagen. Neuladen und Sprachwechsel im selben Tab und am selben Standort zählen innerhalb von 30 Minuten einmal. Kamerascans und einzelne Personen werden nicht gezählt. Frühere Aufrufe sind nicht verfügbar; blockierter Speicher oder Erfassungsfehler können Lücken verursachen.",
    "joinCompletionsDefinition": "Aufrufe der letzten 30 Tage, bei denen eine neue Mitgliedschaft innerhalb von 30 Minuten eine erfolgreiche Wallet-Download-Antwort erhielt. Bestehende Mitglieder, Wiederholungen und fehlgeschlagene Downloads sind ausgeschlossen. Dies bestätigt keine Speicherung in Wallet.",
    "joinConversionDefinition": "Abgeschlossene Beitritte geteilt durch erfasste Aufrufe der letzten 30 Tage. Aktuelle Aufrufe innerhalb ihres 30-Minuten-Fensters sind enthalten. Ohne erfasste Aufrufe ist die Rate nicht verfügbar; Erfassungslücken können das Ergebnis beeinflussen.",
    "missingActivityHelp": "„–“ bedeutet, dass keine Aktivität erfasst wurde. Zeiten werden relativ zu jetzt angezeigt; beim Bewegen des Zeigers über eine Zeit erscheint das genaue Datum in der Zeitzone des Browsers.",
    "missingRateHelp": "„–“ bedeutet, dass nicht genügend geeignete Daten zur Berechnung dieser Rate vorliegen. Es bedeutet nicht 0 %."
  }
}
